<style>
.el-checkbox__input.is-checked .el-checkbox__inner{
  background: #4fa1a4 !important;
  border-color: #4fa1a4 !important;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
  color:#4fa1a4 !important;
}
.back-btn {
  position: absolute;
  top: 12px;
  left: 10px;
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
}
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.field-radio {
  display: flex;
  align-items: center;
}

.field-radio .el-form-item__content {
  margin-left: 0 !important;
}
.el-form-item {
  margin-bottom: 8px;
}

.other-config {
  display: flex;
  font-size: 14px;
  padding-left: 50px;
  /* padding-top: 30px; */
}

.other-content {
  flex: 1;
}

.other-content-list {
  display: flex;
  align-items: center;
  /* margin-bottom: 20px; */
}

.other-title {
  padding-right: 10px;
}

/* 报货配置 */
.bh-config-box {
  display: flex;
  height: 40px;
  align-items: center;
  font-size: 14px;
  padding-left: 50px;
  padding-top: 10px;
}

.bh-config-title {
  margin-right: 10px;
  width: 126px;
  text-align: left;
}

/* 库存信息采集 */
.kc-label {
  font-size: 12px;
  color: #86909c;
}

.kc-label span {
  color: #4fa1a4;
  cursor: pointer;
}

.kc-box {
  padding: 16px;
  box-sizing: border-box;
}

.kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #323232;
}

.kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #323232;
}

.kc-box .el-tabs__item {
  border-right: 1px solid #dcdfe6 !important;
}

.kc-tab-box {
  height: 340px;
  padding: 0 0 40px;
  font-size: 14px;
  overflow-y: auto;
  box-sizing: border-box;
}

.kc-tab-list {
  padding: 0 0 40px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #dcdcdc;
}

.kc-tab-list:last-child {
  padding-bottom: 0;
  border-bottom: none;
}

.kc-tab-label {
  display: flex;
  margin-top: 30px;
}

.label-left-name img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.tab-label-left {
  width: 350px;
  display: flex;
  margin-right: 20px;
}

.label-left-name {
  width: 100px;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  flex-shrink: 0;
}

.tab-label-right {
  display: flex;
  align-items: center;
  color: #c8c8c8;
}

.tab-label-add {
  color: #4fa1a4;
  cursor: pointer;
  margin-right: 10px;
}

.tab-label-del {
  color: #d0021b;
  cursor: pointer;
  margin: 0 10px;
}

.kc-tab-rules {
  display: flex;
  margin-top: 16px;
}

.kc-rules-center {
  display: flex;
  align-items: center;
}

.rules-center-input span {
  margin: 0 8px;
}

.kc-no-label {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kc-no-label img {
  width: 213px;
  margin-right: 35px;
}

.no-label-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.no-label-text h3 {
  font-size: 18px;
  color: #7f828f;
  text-align: left;
  font-weight: 500;
  margin: 0;
}

.no-label-text p {
  font-size: 14px;
  color: #7f828f;
  line-height: 20px;
  margin: 6px 0 13px;
  text-align: left;
}

.no-label-btn {
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 2px;
  text-align: center;
  color: #4fa1a4;
  cursor: pointer;
  border: 1px solid #4fa1a4;
}

.dy-table {
  width: 800px;
  margin-left: 10px;
}
.dy-table .dy-table-title {
  display: flex;
  height: 60px;
  line-height: 60px;
  background: #f2f2f2;
  border-bottom: 1px solid #ddd;
}

.dy-table .dy-table-title div {
  width: 200px;
}

.dy-table .dy-table-item {
  display: flex;
  height: 50px;
  align-items: center;
  border-bottom: 1px solid #ddd;
}

.dy-table-item-label {
  width: 200px;
  flex-shrink: 0;
  text-align: center;
}

.dy-table .dy-radio-box {
  width: 200px !important;
  text-align: center;
}
.dy-table-holiday {
  width: 340px;
  margin-left: 50px;
  border: 1px solid #ddd;
}
.dy-table-holiday .dy-table-title {
  display: flex;
  height: 40px;
  line-height: 40px;
  /* background: #f2f2f2; */
  /* border-bottom: 1px solid #ddd; */
}

.dy-table-holiday .dy-table-title div {
  width: 160px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.dy-table-holiday .dy-table-item {
  display: flex;
  height: 40px;
  align-items: center;
  
  border-bottom: 1px solid #ddd;
}

.dy-table-holiday .dy-table-item-label {
  width: 160px;
  flex-shrink: 0;
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-right: 1px solid #ddd;
}
.dy-table-holiday .dy-radio-box {
  width: 200px !important;
  text-align: center;
}

.dy-config-wrap {
  display: flex;
  font-size: 14px;
  margin: 30px 0;
  padding-left: 50px;
}

.dy-config-title {
  flex-shrink: 0;
  margin-top: 20px;
}

.product-select-all {
  margin-bottom: 20px;
}
.title-content {
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  width: 100%;
}
.title-item {
  vertical-align: middle;
  text-align: center;
  padding-right: 10px;
}
.left-text {
  text-align: left;
}
.w200 {
  width: 30%;
}
.w160 {
  width: 160px;
}
.w240 {
  width: 200px;
}
.w100 {
  width: 100px;
}
.configure-fields {
  width: 880px !important;
}
.configure-fields .el-dialog__body {
  overflow-y: auto;
  max-height: 600px;
}
.el-dialog__footer {
  border-top: 1px solid #d9d9d9;
}
.el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
/* 选项内容样式 */
.select-content-box {
  width: 92%;
  margin: 0 0px 10px 30px;
}
.select-content {
  width: 100%;
  /* padding:0 10px; */
  background: #fafafa;
  border: 1px solid #e5e5e5;
}
.el-form-item__label {
  color: #666;
}
.select-content .el-form-item__label {
  width: 90px !important;
}
.select-content .el-form-item__content {
  margin-left: 90px !important;
}
.config-item .el-form-item__content {
  margin-left: 0px !important;
}
/*  */
.max-value {
  position: relative;
  height: 40px;
}
.max-value .el-input-number--mini {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 104px;
}
.el-image-viewer__wrapper{
  z-index: 2099 !important;
}
</style>
<template>
  <div class="content config-wrap-box" style="background: 0 none" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="function-wrap">
      <h1>{{ subTitle }}</h1>
      <div class="back-btn" @click="$router.go(-1)">返回</div>
    </div>
    <div class="base" style="margin-bottom: 4px">
      <div class="title" style="padding-left: 20px"><span></span>应用方配置</div>
      <div class="base-content">
        <div class="base-info">
          <div class="base-title"><span style="color: red">*</span>应用公司：</div>
          <el-select
            style="width: 300px"
            v-model="tenantName"
            @change="handleSelectFactory"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in sendTenantList"
              :key="index"
              :label="item.tenantName"
              :value="item.tenantName"
            ></el-option>
          </el-select>
        </div>
        <div class="base-info">
          <div class="base-title">应用部门：</div>
          <el-select v-model="organisationGuid" placeholder="请选择" filterable style="width: 300px">
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            ></el-option>
          </el-select>
          <!-- <el-input
              size="mini"
              @focus="handleChooseDepart"
              v-model="organisationNameList"
              style="width: 300px"
              placeholder="请选择"
            ></el-input> -->
        </div>
      </div>
    </div>
    <div class="base">
      <div class="back-color-fff content-main-box">
        <div class="button-area">
          <div class="title" style="padding-left: 20px"><span></span>功能字段配置</div>
          <el-button
            size="mini"
            v-if="addConfig.length && addConfig[0].parameterValue == '开'&&$route.query.type!=3"
            icon="el-icon-plus"
            type="info"
            @click="addFieldConfig"
            >添加字段</el-button
          >
        </div>
        <el-table :data="fieldList" stripe border style="width: 100%" :height="tableHeight">
          <!-- 界面名称 -->
          <el-table-column prop="fieldAlias" label="界面名称" header-align="center" align="left" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.fieldAlias }}</template>
          </el-table-column>
          <!-- 字段名称 -->
          <el-table-column prop="fieldDesc" label="字段名称" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.fieldDesc }}</template>
          </el-table-column>
          <!-- 字段类型 -->
          <el-table-column
            prop="fieldType"
            width="100px"
            label="字段类型"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ getFieldType(scope.row.fieldType) }}</template>
          </el-table-column>
          <!-- 是否展示 -->
          <el-table-column
            prop="formVisible"
            width="70px"
            label="是否展示"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.formVisible == 'Y' ? '是' : '否' }}</template>
          </el-table-column>
          <!-- 是否必填 -->
          <el-table-column
            prop="isRequired"
            width="70px"
            label="是否必填"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.isRequired == 'Y' ? '是' : '否' }}</template>
          </el-table-column>
          <!-- 系统字段 -->
          <el-table-column
            prop="isSysField"
            width="70px"
            label="系统字段"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.isSysField == 'Y' ? '是' : '否' }}</template>
          </el-table-column>
          <!-- 是否明细 -->
          <el-table-column
            prop=""
            width="70px"
            label="是否明细"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="scope">{{ scope.row.isDetail == 'Y' ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column v-if="$route.query.type!=3" prop="bank" width="160px" label="操作" header-align="center" align="left">
            <template slot-scope="scope">
              <a class="txt-color" @click="editFieldConfig(deepCopy(scope.row), scope.$index,'编辑字段')">编辑</a>
             
              <a
                class="txt-color"
                v-if="delConfig.length != 0 && delConfig[0].parameterValue == '开'"
                @click="delVFieldConfig(scope.$index)"
              >
                ｜ 删除</a
              >
              <a class="txt-color" v-if="scope.$index != 0" @click="sortUpField(scope.row, scope.$index)"> | 上移</a>
              <a
                class="txt-color"
                v-if="scope.$index + 1 != fieldList.length"
                @click="sortDownField(scope.row, scope.$index)"
              >
                | 下移</a
              >
            </template>
          </el-table-column>
          <el-table-column v-else prop="bank" width="60px" label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <a class="txt-color" @click="editFieldConfig(deepCopy(scope.row), scope.$index,'查看字段')">查看</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 其他参数配置- -->
      <div
        class="button-area"
        v-if="
          queryCode == 'ZBHZTJ' ||
          queryCode == 'SCDY' ||
          queryCode == 'BHOTC' ||
          queryCode == 'BHSY' ||
          queryCode == 'BHRX' ||
          queryCode == 'WDXSDD' ||
          queryCode == 'WDCGDD' ||
          queryCode == 'TKYL' ||
          queryCode == 'JPXXSJ' ||
          queryCode == 'SWQT' ||
          queryCode == 'TSGL' ||
          queryCode == 'XCPPX' ||
          queryCode == 'ZTBXXCJ' ||
          queryCode == 'ZTBGWXXCJ' ||
          queryCode == 'SBWX' ||
          queryCode == 'SBAZ' ||
          queryCode == 'XFGL' ||
          queryCode == 'KCXXCJ' ||
          queryCode == 'CPPS' ||
          queryCode == 'HCSJRK' ||
          queryCode == 'SSGT' ||
          queryCode == 'SQSH' ||
          queryCode == 'HCPD' ||
          queryCode == 'PYQFX'||
          queryCode == 'THCL' ||
          queryCode == 'ZCXXSJ' ||
          queryCode == 'HYLB' ||
          queryCode == 'YWCL' ||
          queryCode == 'SDYZ' ||
          queryCode == 'YWCL' ||
          queryCode == 'CPXSTG' ||
          queryCode == 'ZBHZTJ' ||
          queryCode == 'KHDK' ||
          queryCode == 'KHLH'||
          queryCode == 'JDSYGS' ||
          queryCode == 'TZYDJD' ||
          queryCode == 'YYJD' ||
          queryCode == 'XSBF' ||
          queryCode == 'FKSXSDD' ||
          queryCode == 'FKSCGDD' 
        "
      >
        <div class="title" style="padding-left: 20px; margin-top: 10px"><span></span>其他参数配置</div>
        
      </div>
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="客户权限" name="first" v-if="showTab1 ">
          <!-- 其他参数配置-拓客引流、客户拜访（市场调研）、竞品信息收集、订单信息收集(医院)、订单信息收集(药店)、SQSH售前售后（应收跟进）、CPPS产品配送、HCSJRK耗材上架入库、SSGT手术跟台、THCL退货处理 -->
          <div
            class="bh-config"
            v-if="
              queryCode == 'ZBHZTJ' ||
              queryCode == 'TKYL' ||
              queryCode == 'SCDY' ||
              queryCode == 'JPXXSJ' ||
              queryCode == 'SDYZ' ||
              queryCode == 'YWCL' ||
              queryCode == 'BHRX' ||
              queryCode == 'BHOTC' ||
              queryCode == 'BHSY' ||
              queryCode == 'SQSH' ||
              queryCode == 'CPPS' ||
              queryCode == 'HCSJRK' ||
              queryCode == 'SSGT' ||
              queryCode == 'THCL' ||
              queryCode == 'SWQT' ||
              queryCode == 'TSGL' ||
              queryCode == 'XCPPX' ||
              queryCode == 'ZTBXXCJ' ||
              queryCode == 'ZTBGWXXCJ' ||
              queryCode == 'SBWX' ||
              queryCode == 'SBAZ' ||
              queryCode == 'XFGL' ||
              queryCode == 'KCXXCJ' ||
              queryCode == 'HCPD' ||
              queryCode == 'CPXSTG' ||
              queryCode == 'HYLB' ||
              queryCode == 'KHLH' 
            "
          >
            <div class="bh-config-box">
              <div class="bh-config-title">快速建档入口：</div>
              <el-radio-group v-model="bizParam1.isFastAdd" @change="radioChange">
                <el-radio label="Y">展示</el-radio>
                <el-radio label="N">不展示</el-radio>
              </el-radio-group>
            </div>
          </div>

          <!-- 一客多人 规则 start -->
          <div class="bh-config"
            v-if="
                queryCode == 'JDSYGS' ||
                queryCode == 'TZYDJD' ||
                queryCode == 'YYJD' 
              "
          >
          <div class="bh-config-box">
            <div class="bh-config-title" content="再过60天就到55岁的人为【年龄超标】" placement="top-start">人员自行指派客户给自己：</div>
              <el-radio v-model="assignRadio" :label="1">
                允许自行指派<span style="color:red">{{'(指派的任务不统计任务量，建议不要派发建档任务)'}}</span>
                <el-tooltip class="item" effect="light" content="如果开启，那么当服务人员填写已经存在的客户名称后，页面的档案内容会自动展示已存在的客户资料，在提交后系统自动将此客户转派给他，无需运营手动分配，转派的客户不统计任务。" placement="top-start">
                  <i class="el-icon-question" style="color: #606266;"></i>
                </el-tooltip>
              </el-radio>
              <el-radio v-model="assignRadio" :label="0">不允许自行指派</el-radio>
          </div>
          </div>
          <!--一客多人 规则 end  -->

          <!-- 其他参数配置-市场调研可见权限 -->
          <div
            class="bh-config dy-config-wrap"
            v-if="
              queryCode == 'YWCL' ||
              queryCode == 'SDYZ' ||
              queryCode == 'ZBHZTJ' ||
              queryCode == 'SCDY' ||
              queryCode == 'JPXXSJ' ||
              queryCode == 'SQSH' ||
              queryCode == 'THCL' ||
              queryCode == 'XFGL' ||
              queryCode == 'KCXXCJ' ||
              queryCode == 'CPPS' ||
              queryCode == 'HCSJRK' ||
              queryCode == 'SSGT' ||
              queryCode == 'HCPD' ||
              queryCode == 'SWQT' ||
              queryCode == 'TSGL' ||
              queryCode == 'XCPPX' ||
              queryCode == 'ZTBXXCJ' ||
              queryCode == 'ZTBGWXXCJ' ||
              queryCode == 'SBWX' ||
              queryCode == 'CPXSTG' ||
              queryCode == 'SBAZ' ||
              queryCode == 'HYLB' ||
              queryCode == 'BHRX' ||
              queryCode == 'BHOTC' ||
              queryCode == 'BHSY' ||
              queryCode == 'XSBF' ||
              queryCode == 'KHLH' 
            "
          >
            <div class="dy-config-title">客户可见权限：</div>
            <div class="dy-table">
              <div class="dy-table-title">
                <div>客户类型</div>
                <div>可见业务员自己数据</div>
                <div>可见所在销售区域的数据</div>
                <div>可见所在公司的数据</div>
              </div>
              <div class="dy-table-item" v-for="(item, index) in visitRadioList" :key="index">
                <div class="dy-table-item-label">{{ item.name }}</div>
                <div class="dy-radio-box">
                  <el-radio
                    v-model="item.competenceParam"
                    @change="customerChange(item.competenceParam, item)"
                    label="CUSTOMER_YWY"
                    ><span></span
                  ></el-radio>
                </div>
                <div class="dy-radio-box">
                  <el-radio
                    v-model="item.competenceParam"
                    @change="customerChange(item.competenceParam, item)"
                    label="CUSTOMER_XSQY"
                    ><span></span
                  ></el-radio>
                </div>
                <div class="dy-radio-box">
                  <el-radio
                    v-model="item.competenceParam"
                    @change="customerChange(item.competenceParam, item)"
                    label="CUSTOMER_GS"
                    ><span></span
                  ></el-radio>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="执行规则" name="second" v-if="showTab2">
           <!-- 市场调研 规则 start -->
          <div class="other-config" v-if="queryCode == 'SCDY'">
            <MarkingRuleConfig ref="markingRuleConfig" :bizParam1=bizParam1 @changeData="changeData" :fieldList="fieldList"></MarkingRuleConfig>
          </div>
          <!--市场调研 规则 end  -->
          <!--竟品信息收集  规则 start -->
          <div class="other-config" v-if="queryCode == 'JPXXSJ'">
            <CompetitionRuleConfig ref="competitionRuleConfig" :bizParam1=bizParam1 @changeData="changeData"></CompetitionRuleConfig>
          </div>
          <!--竟品信息收集 规则 end  -->

            <!--竟品信息收集  规则 start -->
          <div class="other-config" v-if="queryCode == 'YWCL'">
            <GoodsShowRuleConfig ref="goodsShowRuleConfig" :bizParam1=bizParam1 @changeData="changeData"></GoodsShowRuleConfig>
          </div>
          <!--竟品信息收集 规则 end  -->

          <!-- 专病患者统计 规则 start -->
          <div class="other-config" v-if="queryCode == 'ZBHZTJ'">
            <ZbRuleConfig ref="zbRuleConfig" :bizParam1=bizParam1  @changeData="changeData"></ZbRuleConfig>
          </div>
          <!--专病患者统计 规则 end  -->
          <!-- 私域管理 规则 start -->
          <div class="other-config" v-if="queryCode == 'PYQFX'">
            <div class="bh-config-title mt10">分享条数规则：</div>
            <div class="other-content">
              <!--规则 -->
              <div class="other-content-list" v-if="queryCode == 'PYQFX'">
                <el-checkbox v-model="bizParam1.inputLimitPerDay.enabled"></el-checkbox
                ><span class="ml10 mr10">同一人同一天分享条数最多</span>
                <el-input
                  class="w80"
                  v-model="bizParam1.inputLimitPerDay.max"
                  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  type="text"
                  :min="1"
                  :maxlength="4"
                ></el-input
                ><span class="ml10">条</span>
              </div>

              
            </div>
          </div>
          <div class="other-config bh-config-box" v-if="queryCode == 'PYQFX'">
              <div class="bh-config-title">节假日提交规则：</div>
              <el-radio-group v-model="bizParam1.isHolidayRule" @change="radioChange">
                <el-radio label="Y">拦截</el-radio>
                <el-radio label="N">不拦截，友情提醒</el-radio>
              </el-radio-group>
            </div>
          <!--私域管理 规则 end  -->
          <!-- 手术跟台 规则 start -->
          <div class="other-config" v-if="queryCode == 'SSGT'">
            <SsgtRuleConfig ref="ssgtRuleConfig" :bizParam1=bizParam1 @changeData="changeData"></SsgtRuleConfig>
            <!-- <div class="other-title mt10">执行规则：</div>
            <div class="other-content">
            
              <div class="other-content-list">
                <el-checkbox v-model="bizParam1.dayCustomerSameSum.ruleItemList[0].enabled"></el-checkbox
                ><span class="ml10 mr10">同企业所有人同一天内，提交同客户的数据最多</span>
                <el-input
                  class="w80"
                  v-model="bizParam1.dayCustomerSameSum.ruleItemList[0].sumLimitMax"
                  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  type="text"
                  :min="1"
                  :maxlength="4"
                ></el-input
                ><span class="ml10">条</span>
              </div>
            </div> -->
          </div>
          <!--手术跟台 规则 end  -->
           <!-- 其他参数配置-报货 start -->
          <div
            class="bh-config"
            v-if="
              queryCode == 'BHOTC' ||
              queryCode == 'BHRX' ||
              queryCode == 'BHSY' ||
              queryCode == 'WDXSDD' ||
              queryCode == 'WDCGDD' ||
              queryCode == 'FKSXSDD' ||
              queryCode == 'FKSCGDD' 
            "
          >
            <div class="bh-config-box" v-if="queryCode !== 'FKSXSDD'&& queryCode !== 'FKSCGDD'">
              <div class="bh-config-title">采集产品自行填价：</div>
              <el-radio v-model="bizParam1.isChangePrice" label="1">支持</el-radio>
              <el-radio v-model="bizParam1.isChangePrice" label="0">不支持</el-radio>
            </div>
            <div class="bh-config-box" v-if="queryCode !== 'WDXSDD' && queryCode !== 'WDCGDD'">
              <div class="bh-config-title">采集方式：</div>
              <el-radio @input="changeDeclareGoodsType" v-model="bizParam1.declareGoodsType" label="1">按产品规格采集</el-radio>
              <el-radio v-if="queryCode !== 'FKSCGDD'" @input="changeDeclareGoodsType" v-model="bizParam1.declareGoodsType" label="2">按产品批号采集</el-radio>
            </div>
            <div class="bh-config-box" v-if="queryCode == 'WDXSDD' || queryCode == 'WDCGDD'">
              <div class="bh-config-title">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="应用于业务员执行订单任务后是否达标的依据，例如：订单为待审核状态时，任务才算完成。"
                  placement="bottom-start"
                >
                  <span>任务有效定义<i class="el-icon-question"></i></span>
                </el-tooltip>
              </div>
              <el-radio v-model="bizParam1.orderState" label="10">草稿中</el-radio>
              <el-radio v-model="bizParam1.orderState" label="20">待审核</el-radio>
              <el-radio v-model="bizParam1.orderState" label="30">{{
                queryCode == 'WDCGDD' ? '待入库(已审核)' : '待出库(已审核)'
              }}</el-radio>
              <el-radio v-model="bizParam1.orderState" label="50">{{
                queryCode == 'WDCGDD' ? '已入库' : '已出库'
              }}</el-radio>
            </div>
          </div>
          <!-- 其他参数配置-报货 end -->
          <!--  -->
          <div class="other-config"    v-if="
              queryCode == 'FKSXSDD' ||
              queryCode == 'FKSCGDD' ">
            <ReRuleConfig ref="reRuleConfig" :bizParam1=bizParam1 :queryCode="queryCode" @changeData="changeData"></ReRuleConfig>
          </div>
          <!-- 报货规则 start -->
            <div class="other-config"    v-if="
              queryCode == 'BHOTC' ||
              queryCode == 'BHRX' ||
              queryCode == 'BHSY' ">
            <BhRuleConfig ref="bhRuleConfig" :bizParam1=bizParam1 :queryCode="queryCode" @changeData="changeData"></BhRuleConfig>
          </div>
          <!--报货规则 规则 end  -->
          <!-- 产品配送规则 start -->
          <div class="other-config"    v-if="queryCode == 'CPPS'  ">
            <CppsRuleConfig ref="cppsRuleConfig" :bizParam1=bizParam1 @changeData="changeData"></CppsRuleConfig>
          </div>
          <!--产品配送规则 规则 end  -->
          
          <!-- 库存信息采集 start -->
          <div class="other-config" v-if="queryCode == 'KCXXCJ'">
            <KcRuleConfig ref="kcRuleConfig" :bizParam1=bizParam1 @changeData="changeData"></KcRuleConfig>
          </div>
          <!-- 库存信息采集 end -->

        </el-tab-pane>
        <el-tab-pane label="拍照与签到" name="third" v-if="showTab3">
          <!-- 水印 规则 start -->
          <div
            class="bh-config"
            v-if="
              queryCode == 'ZTBGWXXCJ' ||
              queryCode == 'ZTBXXCJ' ||
              queryCode == 'XCPPX' ||
              queryCode == 'THCL' ||
              queryCode == 'CPPS' ||
              queryCode == 'HCSJRK' ||
              queryCode == 'ZCXXSJ' ||
              queryCode == 'HYLB' ||
              queryCode == 'KCXXCJ' ||
              queryCode == 'PYQFX' ||
              queryCode == 'YWCL' ||
              queryCode == 'SDYZ' ||
              queryCode == 'CPXSTG' ||
              queryCode == 'TKYL' ||
              queryCode == 'SCDY' ||
              queryCode == 'SWQT' ||
              queryCode == 'TSGL' ||
              queryCode == 'SBAZ' ||
              queryCode == 'SBWX' ||
              queryCode == 'HCPD' ||
              queryCode == 'SQSH' ||
              queryCode == 'SSGT' ||
              queryCode == 'ZBHZTJ' ||
              queryCode == 'XFGL' ||
              queryCode == 'KHDK' ||
              queryCode == 'JPXXSJ' ||
              queryCode == 'KHLH'
            "
          >
            <div class="bh-config-box">
              <el-popover trigger="hover" width="220" placement="top-start">
                <div>{{ '开启后，业务员在进行拍照后系统自动给照片加上当时的时间水印和位置水印' }}</div>
                <template slot="reference">
                  <i class="el-icon-question"></i>
                </template>
              </el-popover>
              <div class="bh-config-title">水印拍照开关：</div>
              <el-radio-group v-model="bizParam1.isAddWaterMark">
                <el-radio label="Y">开启
                  <!-- <span class="red">(签到位置必须设为展示，便于用户校正水印位置)</span> -->
                </el-radio>
                <el-radio label="N">关闭</el-radio>
              </el-radio-group>
            </div>
            <div class="bh-config-box">
              <el-popover trigger="hover" width="220" placement="top-start">
                <div>{{ '开启后，做任务才可以从相册选图' }}</div>
                <template slot="reference">
                  <i class="el-icon-question"></i>
                </template>
              </el-popover>
              <div class="bh-config-title">从相册选图开关：</div>
              <el-radio-group v-model="bizParam1.isOnlyCamera" >
                <el-radio label="N">开启
                  <!-- <span class="red">(开启后，做任务才可以从相册选图)</span> -->
                </el-radio>
                <el-radio label="Y">关闭</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- 水印 规则 end -->
          <!-- 签到 规则 start -->
          <div
            class="bh-config"
            v-if="
              queryCode == 'SCDY' ||
              queryCode == 'SWQT' ||
              queryCode == 'XCPPX' ||
              queryCode == 'TSGL' ||
              queryCode == 'SBAZ' ||
              queryCode == 'SBWX' ||
              queryCode == 'HCPD' ||
              queryCode == 'SQSH' ||
              queryCode == 'SSGT' ||
              queryCode == 'ZBHZTJ' ||
              queryCode == 'XFGL' ||
              queryCode == 'KHDK' ||
              queryCode == 'JPXXSJ' ||
              queryCode == 'KHLH'
            "
          >
            <div class="bh-config-box">
              <div class="bh-config-title">现场签到范围：</div>
              <el-input
                  class="w80"
                  v-model="bizParam1.signLocation.maxRadius"
                  oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                  type="text"
                  :min="1"
                  :maxlength="6"
                ></el-input
                ><span class="ml10">米</span>
            </div>
            <div class="bh-config-box">
              <div class="bh-config-title">范围外签到：</div>
              <el-radio-group v-model="bizParam1.signLocation.allowOutside" @change="signChange">
                <el-radio label="Y">允许范围外签到</el-radio>
                <el-radio label="N">不允许范围外签到</el-radio>
              </el-radio-group>
            </div>
          </div>
          <!-- 签到 规则 end -->
        </el-tab-pane>
        
        <el-tab-pane label="移动端标签" name="four" v-if="showTab4">
            <!-- 其他参数配置-库存信息采集 start -->
            <div class="bh-config" v-if="queryCode == 'KCXXCJ'">
            <div class="bh-config-box">
              <div class="bh-config-title">移动端标签：</div>
              <el-radio v-model="bizParam1.isKcShow" label="Y" @change="radioChange">展示</el-radio>
              <el-radio v-model="bizParam1.isKcShow" label="N" @change="radioChange">不展示</el-radio>
              <div class="kc-label">标签的用途？<span @click="onPreview">点我查看</span></div>
            </div>
            <div class="kc-box" v-if="bizParam1.isKcShow == 'Y'">
              <el-tabs type="border-card">
                <!-- 有效期标签 -->
                <el-tab-pane label="有效期标签">
                  <div class="kc-tab-box">
                    <div class="kc-tab-list" v-for="(item, index) in expiryDateList" :key="index">
                      <div class="kc-tab-label">
                        <div class="tab-label-left">
                          <div class="label-left-name">
                            <span>标签{{ index + 1 }}：</span>
                            <img src="../../assets/images/label_icon.png" alt="" />
                          </div>
                          <el-input type="text" v-model="item.tag" placeholder="请输入" :maxlength="20"></el-input>
                        </div>
                        <div class="tab-label-right">
                          <span class="tab-label-add" @click="addLabel()">添加标签</span> |
                          <span class="tab-label-del" @click="delLabel(index)">删除</span>
                        </div>
                      </div>
                      <div class="kc-tab-rules" v-for="(items, index1) in item.rule" :key="index1">
                        <div class="tab-label-left">
                          <div class="label-left-name">规则{{ index1 + 1 }}：</div>
                          <el-select
                            v-model="items.selectName"
                            placeholder="请选择"
                            style="flex: 1"
                            @change="changeSelectNameSelect(items, index, index1)"
                          >
                            <el-option
                              v-for="item in optionsKcProductType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                          <span
                            style="line-height: 36px; color: #4fa1a4; margin-left: 30px; cursor: pointer"
                            v-if="items.selectName !== 'ALL'"
                            @click="changeSelect(items, index, index1)"
                            >{{ items.selectNum > 0 ? '已选' + items.selectNum + '个' : '选择产品' }}</span
                          >
                        </div>
                        <div class="kc-rules-center">
                          <div class="rules-center-label">当有效期：</div>
                          <el-select
                            v-model="items.ruleConfigType"
                            placeholder="请选择"
                            style="width: 110px; margin-right: 10px"
                            @change="ruleChange(items.ruleConfigType, index, index1)"
                          >
                            <el-option v-for="item in optionsKc" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                          <div class="rules-center-input" v-if="items.ruleConfigType !== 'gt_lt'">
                            <el-input
                              v-model="items.value1"
                              placeholder="输入天数"
                              style="width: 110px"
                              @change="kcStartChange(items, index, index1)"
                            ></el-input
                            ><span>天时</span>
                          </div>
                          <div class="rules-center-input" v-else>
                            <el-input
                              v-model="items.value1"
                              placeholder="输入天数"
                              style="width: 110px"
                              @change="kcStartChange(items, index, index1)"
                            ></el-input
                            ><span>至</span
                            ><el-input
                              v-model="items.value2"
                              @change="kcEndChange(items, index, index1)"
                              style="width: 110px"
                              placeholder="输入天数"
                            ></el-input
                            ><span>天时</span>
                          </div>
                        </div>
                        <div class="tab-label-right ml20">
                          <span class="tab-label-add" @click="addRule(index)">添加规则</span
                          ><span v-if="item.rule && item.rule.length > 1">
                            | <span class="tab-label-del" @click="delRule(index, index1)">删除</span></span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="kc-no-label" v-show="expiryDateList == 0">
                      <img src="../../assets/images/no_label_icon.png" alt="" />
                      <div class="no-label-text">
                        <h3>暂无标签</h3>
                        <p>输入库存数量/有效期时<br />展示建议标签提醒业务员</p>
                        <div class="no-label-btn" @click="addLabel()">添加标签</div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <!-- 库存数标签 -->
                <el-tab-pane label="库存数标签">
                  <div class="kc-tab-box">
                    <div class="kc-tab-list" v-for="(item, index) in stockNumList" :key="index">
                      <div class="kc-tab-label">
                        <div class="tab-label-left">
                          <div class="label-left-name">
                            <span>标签{{ index + 1 }}：</span>
                            <img src="../../assets/images/label_icon.png" alt="" />
                          </div>
                          <el-input v-model="item.tag" placeholder="请输入" :maxlength="20"></el-input>
                        </div>
                        <div class="tab-label-right">
                          <span class="tab-label-add" @click="addLabel(1)">添加标签</span> |
                          <span class="tab-label-del" @click="delLabel(index, 1)">删除</span>
                        </div>
                      </div>
                      <div class="kc-tab-rules" v-for="(items, index1) in item.rule" :key="index1">
                        <div class="tab-label-left">
                          <div class="label-left-name">规则{{ index1 + 1 }}：</div>
                          <el-select
                            v-model="items.selectName"
                            placeholder="请选择"
                            style="flex: 1"
                            @change="changeSelectNameSelect(items, index, index1, 1)"
                          >
                            <el-option
                              v-for="item in optionsKcProductType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                          <span
                            style="line-height: 36px; color: #4fa1a4; margin-left: 30px; cursor: pointer"
                            v-if="items.selectName !== 'ALL'"
                            @click="changeSelect(items, index, index1, 1)"
                            >{{ items.selectNum > 0 ? '已选' + items.selectNum + '个' : '选择产品' }}</span
                          >
                          <!-- <el-select  v-model="items.value" placeholder="请选择" style="flex:1">
                              <el-option
                                v-for="item in optionsKc"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-select> -->
                        </div>
                        <div class="kc-rules-center">
                          <div class="rules-center-label">当库存数量：</div>
                          <el-select
                            v-model="items.ruleConfigType"
                            placeholder="请选择"
                            @change="ruleChange(items.ruleConfigType, index, index1, 1)"
                            style="width: 110px; margin-right: 10px"
                          >
                            <el-option v-for="item in optionsKc" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                          </el-select>
                          <div class="rules-center-input" v-if="items.ruleConfigType !== 'gt_lt'">
                            <el-input
                              v-model="items.value1"
                              placeholder="输入数值"
                              style="width: 110px"
                              @change="kcStartChange(items, index, index1)"
                            ></el-input
                            ><span>时</span>
                          </div>
                          <div class="rules-center-input" v-else>
                            <el-input
                              v-model="items.value1"
                              placeholder="输入数值"
                              @change="kcStartChange(items, index, index1, 1)"
                              style="width: 110px"
                            ></el-input
                            ><span>至</span
                            ><el-input
                              v-model="items.value2"
                              @change="kcEndChange(items, index, index1, 1)"
                              style="width: 110px"
                              placeholder="输入数值"
                            ></el-input
                            ><span>时</span>
                          </div>
                        </div>
                        <div class="tab-label-right ml20">
                          <span class="tab-label-add" @click="addRule(index, 1)">添加规则</span
                          ><span> | <span class="tab-label-del" @click="delRule(index, index1, 1)">删除</span></span>
                        </div>
                      </div>
                    </div>
                    <div class="kc-no-label" v-if="stockNumList.length == 0">
                      <img src="../../assets/images/no_label_icon.png" alt="" />
                      <div class="no-label-text">
                        <h3>暂无标签</h3>
                        <p>输入库存数量/有效期时<br />展示建议标签提醒业务员</p>
                        <div class="no-label-btn" @click="addLabel(1)">添加标签</div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <!-- 其他参数配置-库存信息采集 end  -->
        </el-tab-pane>
        <el-tab-pane label="节假日规则" name="five" v-if="showTab5">
          <div
            class="vacation-config"
            v-if="
              queryCode == 'SCDY' ||
              queryCode == 'ZBHZTJ' ||
              queryCode == 'HYLB' ||
              queryCode == 'BHRX' ||
              queryCode == 'BHOTC' ||
              queryCode == 'BHSY' ||
              queryCode == 'KCXXCJ'
            "
          >
            <div class="bh-config-box">
              <div style="width:200px" class="bh-config-title">服务人员节假日提交任务规则：</div>
             
            </div>
            <!-- <div class="dy-config-title">服务人员节假日提交任务规则：</div> -->
            <div class="dy-table-holiday">
              <div class="dy-table-title">
                <div>拜访客户类型</div>
                <div style="width:180px">节假日拜访是否拦截</div>
              </div>
              <div class="dy-table-item" v-for="(item, index) in holidayRuleList" :key="index">
                <div class="dy-table-item-label">{{ item.name }}</div>
                <div class="dy-radio-box">
                  <!-- <el-radio
                    v-model="item.isIntercept"
                    @change="customerChange(item.competenceParam, item)"
                    
                    ><span></span
                  ></el-radio> -->
                  <el-switch
                    v-model="item.isCheckHoliday"
                    active-color="#4FA1A4"
                    inactive-color="#BABABA">
                  </el-switch>
                </div>
               
                
              </div>
            </div>
            
          </div>
        </el-tab-pane>
        <!-- 采集日期规则 -->
        <el-tab-pane label="采集日期规则" name="six" v-if="showTab6">
          <div
            class="vacation-config"
            v-if="['BHSY', 'BHOTC', 'BHRX'].includes(queryCode)"
          >
            <!-- 规则1：采集日期范围 -->
            <div style="margin-top: 20px;">
              <div style="width:200px; margin-bottom: 15px;">规则1：采集日期范围：</div>
              <div class='flex items_center' style="margin-left: 40px; gap: 10px">
                <div class='flex items_center'>
                  <el-checkbox v-model="bizParam1.accountMonthCheckRule.enabled" style="margin-right: 5px;"></el-checkbox>
                  <span style="white-space: nowrap;">可选当前任务包核算月的</span>
                </div>
                <el-select
                  v-model="bizParam1.accountMonthCheckRule.amount"
                  placeholder="请选择"
                  style="width: 120px;">
                  <el-option
                    v-for="item in getCodeListByKey('订单采集任务采集日期规则')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div class='flex items_center'>
                  <el-checkbox v-model="bizParam1.accountMonthCheckRule.includeCurrentMonth" style="margin-right: 5px;"></el-checkbox>
                  <span style="white-space: nowrap;">允许选择当前核算月</span>
                </div>
                <el-tooltip class="item" effect="light" placement="top-start">
                  <div slot="content">
                    例如当前任务包核算月为7月，选"前3个月"且不选"当前月"，则仅可选4、5、6月
                  </div>
                  <i class="el-icon-question" style="color: #606266"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      
     

     
      
   
      <template v-if="$route.query.type!=3">
        <el-button size="small" type="info" style="width: 200px; margin-top: 10px" @click="$router.go(-1)">取消</el-button>
        <el-button size="small" type="info" style="width: 200px; margin-top: 10px" @click="saveReq">提交</el-button>
        <el-button size="small" type="info" style="width: 200px; margin-top: 10px" @click="saveReq(1)"
          >提交并预览</el-button
        >
      </template>
    </div>
    <el-dialog title="选择部门" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @check="handleNodeClick1"
              :check-strictly="true"
              show-checkbox
              ref="tree"
              node-key="guid"
              v-if="visible3"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个部门</p>
            <el-button size="mini" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px"
              >批量删除</el-button
            >
            <el-table
              :data="departmentList"
              border
              height="280px"
              style="width: 100%"
              @selection-change="handleSelectionChange1"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="名称"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="mini" @click="visible3 = false">取消</el-button>
        <el-button size="mini" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
    <!-- //! 编辑弹框 -->
    <el-dialog
      :title="textTitle"
      top="5vh"
      custom-class="configure-fields"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px" :label-position="right" class="demo-ruleForm">
        <div class="title" style="padding-left: 20px"><span></span>基本配置</div>
        <el-row>
          <el-col :span="12">
            <!-- 字段名称 -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">字段名称： </span>
              <el-input
               class="fl w240" 
               type="input" 
               placeholder="点击填写" 
               :disabled="textTitle == '编辑字段' && editConfig.length && editConfig[0].parameterValue == '关'"
               v-model="configForm.fieldDesc" />
              <!-- <el-select
                    class="fl"
                    style="width: 450px"
                    v-model="configForm.fieldDesc"
                    @change="handleSelectField"
                    filterable
                    placeholder="请选择"
                    :disabled ="textTitle=='编辑字段'&&editConfig.length&&editConfig[0].parameterValue=='关'"
                  >
                    <el-option
                      v-for="item in fieldOptionList"
                      :key="item.fieldDesc"
                      :label="item.fieldDesc"
                      :value="item.fieldDesc"
                    ></el-option>
                  </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 字段编码 -->
            <el-form-item v-show="editConfig.length && editConfig[0].parameterValue == '开'">
              <span slot="label" style="color: red">*</span>
              <span slot="label">字段编码：</span>
              <el-input
                class="fl w240"
                type="input"
                :maxlength="30"
                placeholder="点击填写"
                v-model="configForm.fieldName"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <!-- 界面名称 -->
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">界面名称： </span>
              <el-input
                class="fl w240"
                type="input"
                :maxlength="30"
                placeholder="点击填写"
                v-model="configForm.fieldAlias"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" style="color: red">*</span>
              <span slot="label">字段类型：</span>
              <el-select
                class="fl w240"
                filterable
                v-model="configForm.fieldType"
                placeholder="请选择"
                :disabled="textTitle == '编辑字段' && editConfig.length && editConfig[0].parameterValue == '关'"
                @change="changeSysVal"
              >
                <el-option
                  v-for="item in fieldTypeList"
                  :key="item.key"
                  :label="item.key"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <!-- 是否可编辑哦 -->
          <el-col :span="24" v-if="configForm.fieldName=='description'">
            <el-form-item label="是否可编辑：" class="field-radio">
              <span slot="label" style="color: red">*</span>
              <span slot="label">是否可编辑：</span>
              <el-radio-group class="fl" v-model="configForm.isUpdate" @change="isUpdateChange">
                <el-radio label="Y">是</el-radio>
                <el-radio label="N">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <!-- 应用端 -->
          <el-col :span="24">
            <el-form-item label="应用端:" class="field-radio">
              <span slot="label" style="color: red">*</span>
              <span slot="label">应用端：</span>
              <el-radio-group class="fl" v-model="configForm.appSideType">
                <el-radio label="0">所有端</el-radio>
                <el-radio label="1">移动端</el-radio>
                <el-radio label="2">PC端</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <!-- 系统字段 -->
            <el-form-item
              label="系统字段:"
              class="field-radio"
              v-show="editConfig.length && editConfig[0].parameterValue == '开'"
            >
              <span slot="label" style="color: red">*</span>
              <span slot="label">系统字段：</span>
              <el-radio-group
                class="fl"
                v-model="configForm.isSysField"
                :disabled="textTitle == '编辑字段' && editConfig.length && editConfig[0].parameterValue == '关'"
                @change="changeSysVal"
              >
                <el-radio label="Y">是</el-radio>
                <el-radio label="N">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 是否展示 -->
        <el-form-item label="是否展示:" class="field-radio">
          <span slot="label" style="color: red">*</span>
          <span slot="label">是否展示：</span>
          <el-radio-group
            class="fl"
            v-model="configForm.formVisible"
            :disabled="configForm.isSysField == 'Y'"
            @input="changeFormVisible"
          >
            <el-radio label="Y">展示</el-radio>
            <el-radio label="N">不展示</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 展示位置 -->
        <el-form-item label="展示位置:" class="field-radio">
          <span slot="label" style="color: red" v-if="configForm.formVisible == 'Y'">*</span>
          <span slot="label">展示位置：</span>
          <el-checkbox-group
            style="display: flex; flex-wrap: wrap; margin-bottom: -16px"
            class="fl"
            v-model="configForm.showPosition"
            @change="changeShowPosition"
          >
            <el-checkbox class="checkbox-show" label="1">任务新增/编辑页面</el-checkbox>
            <el-checkbox :disabled="checkCPMX_disable" class="checkbox-show" label="2"
              >移动端-待整改列表页面</el-checkbox
            >
            <el-checkbox :disabled="checkCPMX_disable" class="checkbox-show" label="3">PC端-任务审核页/待整改任务页
              <el-popover trigger="hover" width="220" placement="top-end">
                <div>{{ '目前仅支持PC端待整改：客户拜访和三类流向采集任务的字段配置' }}</div>
                <template slot="reference">
                  <i class="el-icon-question"></i>
                </template>
              </el-popover>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- 是否明细 -->
        <el-form-item
          label="是否明细:"
          class="field-radio"
          v-show="editConfig.length && editConfig[0].parameterValue == '开'"
        >
          <span slot="label" style="color: red">*</span>
          <span slot="label">是否明细：</span>
          <el-radio-group class="fl" v-model="configForm.isDetail">
            <el-radio label="Y">是</el-radio>
            <el-radio label="N">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否必填:" class="field-radio">
          <span slot="label" style="color: red">*</span>
          <span slot="label">是否必填：</span>
          <el-radio-group class="fl" v-model="configForm.isRequired" :disabled="configForm.isSysField == 'Y'">
            <el-radio label="Y">必填</el-radio>
            <el-radio label="N">非必填</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 选项方式 -->
        <el-form-item
          label="选项方式:"
          class="field-radio"
          v-show="
            (configForm.fieldType == 'radio' ||
              configForm.fieldType == 'mulRadio' ||
              configForm.fieldType == 'customerType') &&
            editConfig.length &&
            editConfig[0].parameterValue == '开'
          "
        >
          <span slot="label" style="color: red">*</span>
          <span slot="label">选项方式：</span>
          <el-radio-group
            class="fl"
            :disabled="textTitle == '编辑字段' && editConfig.length && editConfig[0].parameterValue == '关'"
            v-model="configForm.optionType"
            @change="changeXXFS"
          >
            <el-radio label="1">选项方式1</el-radio>
            <el-radio label="2">选项方式2</el-radio>
            <el-radio label="3">自定义选项</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- // !选择平台字典 -->
        <el-form-item
          label="选择平台字典:"
          v-if="
            (configForm.fieldType == 'radio' ||
              configForm.fieldType == 'mulRadio' ||
              configForm.fieldType == 'customerType') &&
            (configForm.optionType === '1' || configForm.optionType === '2') &&
            editConfig.length &&
            editConfig[0].parameterValue == '开'
          "
        >
          <span slot="label">选择平台字典：</span>
          <el-select
            class="fl w200"
            filterable
            clearable
            v-model="configForm.dictionaryName"
            placeholder="请选择"
            :disabled="textTitle == '编辑字段' && editConfig.length && editConfig[0].parameterValue == '关'"
            @change="changeDictionaryType"
          >
            <el-option
              v-for="item in dictionaryTypeList"
              :disabled="item.disabled"
              :key="item.key"
              :label="item.key"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 非调研对象start -->
        <template
          v-if="
            (configForm.fieldType == 'radio' ||
              configForm.fieldType == 'mulRadio' ||
              configForm.fieldType == 'customerType') &&
            !(configForm.fieldName == 'visitObjectType' && queryCode == 'SCDY')
          "
        >
          <!-- 停线原因 -->
          <template v-if="configForm.fieldName == 'stopReason'">
            <!-- // !5.25以前的选项内容逻辑 -->
            <el-form-item label="选项内容:" class="field-radio">
              <!-- <span slot="label" style="color: red">*</span> -->
              <span slot="label">选项内容：</span>
              <el-button size="small" icon="el-icon-plus" type="info" @click="toSetting">去设置</el-button>
            </el-form-item>
          </template>
          <!-- // !5.25以前的选项内容逻辑 -->
          <!-- <template v-if="configForm.fieldName != 'stopReason'">
            <el-form-item label="选项内容:" class="field-radio">
              <span slot="label" style="color: red">*</span>
              <span slot="label">选项内容：</span>
              <el-button size="small" icon="el-icon-plus" type="info" @click="addSelect">添加选项</el-button>
            </el-form-item>

            <el-form-item v-for="(item, index) in selectItemList" :key="index">
              <span slot="label" style="color: red">*</span>
              <span slot="label">选项：</span>
              <el-input
                class="fl"
                style="width: 200px"
                type="input"
                :maxlength="30"
                placeholder="参数名称"
                v-model="item.text"
              />
              <el-select
                v-if="configForm.fieldType == 'customerType'"
                class="fl"
                style="width: 200px; margin: 0 10px"
                v-model="item.value"
                @change="handleSelectCustomer(item.value, index)"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in customerOption"
                  :key="index"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-input
                v-if="configForm.fieldType !== 'customerType'"
                class="fl"
                style="width: 200px; margin: 0 10px"
                type="input"
                :maxlength="30"
                placeholder="参数值"
                v-model="item.value"
              />

              <el-input
                class="fl"
                style="width: 70px"
                type="input"
                :maxlength="30"
                placeholder="排序"
                v-model="item.orderNum"
              />
              <span @click="delSelect(index)" style="float: left; margin-left: 20px; cursor: pointer">删除</span>
            </el-form-item>
          </template> -->
          <!--  -->

          <!-- 非停线原因 -->
          <!-- // todo 5.25后优化的选项内容逻辑 -->
          <template v-if="configForm.fieldName != 'stopReason' && configForm.optionType">
            <el-form-item class="field-radio" :style="configForm.optionType === '3' ? '' : 'margin-bottom:0'">
              <!-- <span slot="label" style="color: red">*</span> -->
              <span slot="label">选项内容：</span>
              <!-- // todo 自定义选项 -->
              <el-button
                size="small"
                v-if="configForm.optionType === '3'"
                icon="el-icon-plus"
                type="info"
                @click="addSelect"
                >添加选项</el-button
              >
            </el-form-item>
            <div v-if="selectItemList.length" class="select-content-box">
              <div class="select-content">
                <!-- 字段标题 -->
                <div>
                  <div class="title-content">
                    <div style="width: 90px; height: 10px"></div>
                    <div v-if="configForm.optionType !== '2'" class="fl title-item w160 left-text">
                      {{ '界面名称' }}
                    </div>
                    <div
                      :style="configForm.optionType === '2' ? 'padding-left: 10px;' : ''"
                      class="fl title-item w120 left-text"
                    >
                      {{ '字段名称' }}
                    </div>
                    <div 
                      v-if="configForm.optionType == '3'&&configForm.fieldName=='description'&&configForm.isUpdate=='N'"
                      :style="configForm.optionType === '3'&&configForm.fieldName=='description'&&configForm.isUpdate=='N' ? 'padding-left: 40px;' : ''"
                      class="fl title-item w160 left-text"
                   >{{ '关联拜访对象' }}</div>
                    <div v-if="configForm.optionType !== '2'" class="fl title-item w50 left-text">{{ '界面排序' }}</div>
                  </div>
                </div>

                <!-- // todo 选项方式1逻辑 -->
                <template v-if="configForm.optionType === '1'">
                  <el-form-item v-for="(item, index) in selectItemList" :key="index">
                    <span slot="label" style="color: red">*</span>
                    <span slot="label">选项{{ index + 1 }}：</span>
                    <el-input class="fl w160" type="input" :maxlength="30" placeholder="参数名称" v-model="item.text">
                    </el-input>
                    <!-- 客户类型 -->
                    <!-- // ! 字段类型和平台字典同时为客户类型时, 才取客户类型配置 dict/data/get-dict?functionCode=XXX -->
                    <el-select
                      v-if="configForm.fieldType == 'customerType' && configForm.dictionaryName === '客户类型'"
                      class="fl w160"
                      style="margin: 0 10px"
                      v-model="item.value"
                      @change="handleSelectCustomer(item.value, index)"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in customerOption"
                        :key="index"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <!-- //todo 非客户类型且没有选择字典, 可自己填写参数值 -->
                    <el-input
                      v-if="configForm.fieldType !== 'customerType' && !configForm.dictionaryName"
                      class="fl w120"
                      style="margin: 0 10px"
                      type="input"
                      :maxlength="30"
                      placeholder="参数值"
                      v-model="item.value"
                    >
                    </el-input>
                    <!-- //todo 选择字典的场景 -->
                    <el-input
                      v-if="configForm.fieldType !== 'customerType' && configForm.dictionaryName"
                      disabled
                      class="fl w120"
                      style="margin: 0 10px"
                      type="input"
                      :maxlength="30"
                      placeholder="参数值"
                      v-model="item.label"
                    >
                    </el-input>

                    <el-input
                      class="fl father"
                      style="width: 60px"
                      type="input"
                      :maxlength="30"
                      placeholder="排序"
                      v-model="item.orderNum"
                    />
                    <el-checkbox class="fl field-show" v-model="item.isShow">展示</el-checkbox>
                  </el-form-item>
                </template>
                <!-- // todo 选项方式2逻辑 -->
                <template v-if="configForm.optionType === '2'">
                  <el-form-item v-for="(item, index) in selectItemList" :key="index">
                    <span slot="label" style="color: red">*</span>
                    <span slot="label">选项：</span>
                    <!-- <el-input
                        class="fl father"
                        style="width: 200px"
                        type="input"
                        :maxlength="30"
                        placeholder="参数名称"
                        v-model="item.text"
                      >
                      </el-input> -->
                    <!-- 客户类型 -->
                    <el-select
                      v-if="configForm.fieldType == 'customerType'"
                      class="fl father"
                      style="width: 530px"
                      v-model="item.value"
                      @change="handleSelectCustomer(item.value, index)"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in customerOption"
                        :key="index"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <!-- //todo 非客户类型且没有选择字典, 可自己填写参数值 -->
                    <!-- <el-input v-if="configForm.fieldType !== 'customerType' && !configForm.dictionaryName" class="fl father" style="width: 200px; margin: 0 10px"
                        type="input" :maxlength="30" placeholder="参数值" v-model="item.value">
                      </el-input> -->
                    <el-select
                      v-if="configForm.fieldType !== 'customerType'"
                      class="fl father"
                      style="width: 530px"
                      v-model="item.value"
                      @change="handleSelectCustomer(item.value, index)"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in selectDictionaryList"
                        :key="index"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <!-- //todo 选择字典的场景 -->
                  </el-form-item>
                </template>
                <!-- // todo 选项方式3逻辑 -->
                <template v-if="configForm.optionType === '3'">
                  <el-form-item v-for="(item, index) in selectItemList" :key="index">
                    <span slot="label" style="color: red">*</span>
                    <span slot="label">选项{{ index + 1 }}：</span>
                    <el-input class="fl w160" type="input" :maxlength="30" placeholder="参数名称" v-model="item.text" />
                    <!-- 客户类型 -->
                    <el-select
                      v-if="configForm.fieldType == 'customerType'"
                      class="fl w160"
                      style="margin: 0 10px"
                      v-model="item.value"
                      @change="handleSelectCustomer(item.value, index)"
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in customerOption"
                        :key="index"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <!-- 非客户类型 -->
                    <el-input
                      v-if="configForm.fieldType !== 'customerType'"
                      class="fl w120"
                      style="margin: 0 10px"
                      type="input"
                      :maxlength="30"
                      placeholder="参数值"
                      v-model="item.value"
                    />
                    <el-select
                      v-if="configForm.fieldName=='description'&&configForm.isUpdate=='N'"
                      class="fl w180"
                      style="margin: 0 10px"
                      v-model="item.type"
                      collapse-tags
                      multiple
                      filterable
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item, index) in customerOption"
                        :key="index"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>

                    <el-input
                      class="fl w160"
                      style="width: 60px"
                      type="input"
                      :maxlength="30"
                      placeholder="排序"
                      v-model="item.orderNum"
                    />
                    <span
                      @click="delSelect(index)"
                      style="float: left; margin-left: 20px; cursor: pointer; color: #4fa1a4"
                      >删除</span
                    >
                  </el-form-item>
                </template>
              </div>
            </div>
          </template>
        </template>
        <!-- 非调研对象end -->

        <!--调研对象 start // !5.25以前的逻辑  -->
        <template v-if="configForm.fieldName == 'visitObjectType' && queryCode == 'SCDY' && !configForm.dictionaryName">
          <el-form-item label="选项内容:" class="field-radio">
            <!-- <span slot="label" style="color: red">*</span> -->
            <span slot="label">选项内容：</span>
            <el-button size="small" icon="el-icon-plus" type="info" @click="addFirstSelectDy">添加选项</el-button>
          </el-form-item>
          <div class="select-content-box">
            <div class="select-content">
              <!-- 字段标题 -->
              <div>
                <div class="title-content">
                  <div style="width: 90px; height: 10px"></div>
                  <div v-if="configForm.optionType !== '2'" class="fl title-item w160 left-text">{{ '界面名称' }}</div>
                  <div class="fl title-item w160 left-text">{{ '字段名称' }}</div>
                  <div v-if="configForm.optionType !== '2'" class="fl title-item w50 left-text">{{ '界面排序' }}</div>
                </div>
              </div>

              <div class="config-item" v-for="(i, j) in additionalProp1.config" :key="j">
                <el-form-item>
                  <span slot="label" style="color: red">*</span>
                  <span slot="label" style="font-weight: 700">选项{{ j + 1 }}：</span>
                  <el-input class="fl w160" type="input" :maxlength="30" placeholder="参数名称" v-model="i.text" />
                  <el-select
                    class="fl w160"
                    style="margin: 0 10px"
                    v-model="i.value"
                    @change="handleSelectCustomer(i.value, j)"
                    filterable
                    placeholder="请选择"
                  >
                    <el-option v-for="(k, l) in customerOption" :key="l" :label="k.text" :value="k.value"></el-option>
                  </el-select>
                  <!--  -->
                  <!-- <el-input
                      class="fl"
                      style="width: 100px; margin: 0 10px"
                      type="input"
                      :maxlength="30"
                      placeholder="参数值"
                      v-model="i.value"
                    /> -->
                  <el-input
                    class="fl"
                    style="width: 60px"
                    type="input"
                    :maxlength="30"
                    placeholder="排序"
                    v-model="i.orderNum"
                  />
                  <span
                    @click="addSecondSelectDy(j)"
                    style="float: left; margin-left: 20px; cursor: pointer; color: #4fa1a4"
                    >添加文案</span
                  >
                  <span
                    @click="delDyFirstSelect(j)"
                    style="float: left; margin-left: 20px; cursor: pointer; color: #4fa1a4"
                    >删除</span
                  >
                </el-form-item>
                <div style="background: #f2f2f2; padding: 10px 0; margin-bottom: 20px">
                  <!-- <el-form-item class="field-radio">
                    <span slot="label" style="color: red">*</span>
                    <span slot="label">文案内容：</span>
                    <el-button size="small" icon="el-icon-plus" type="info" @click="addSecondSelectDy(j)"
                      >添加文案</el-button
                    >
                  </el-form-item> -->
                  <el-form-item v-for="(k, l) in i.additionalList" :key="l">
                    <span slot="label" style="color: red">*</span>
                    <span slot="label">文案{{ l + 1 }}：</span>
                    <el-input class="fl w160" type="input" :maxlength="30" placeholder="参数名称" v-model="k.text" />
                    <el-input
                      class="fl w160"
                      style="margin: 0 10px"
                      type="input"
                      :maxlength="30"
                      placeholder="参数值"
                      v-model="k.value"
                    />
                    <el-input
                      class="fl"
                      style="width: 60px"
                      type="input"
                      :maxlength="30"
                      placeholder="排序"
                      v-model="k.orderNum"
                    />
                    <span
                      @click="delDySecondSelect(j, l)"
                      style="float: left; margin-left: 20px; cursor: pointer; color: #4fa1a4"
                      >删除</span
                    >
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!--调研对象 // !5.25后的逻辑 -->
        <!-- // ! SCDY 特殊处理逻辑 -->
        <template
          v-if="
            configForm.fieldName == 'visitObjectType' && queryCode == 'SCDY' && configForm.dictionaryName === '客户类型'
          "
        >
          <el-form-item label="选项内容:" class="field-radio">
            <!-- <span slot="label" style="color: red">*</span> -->
            <span slot="label">选项内容：</span>
            <el-button
              v-if="configForm.optionType === '3'"
              size="small"
              icon="el-icon-plus"
              type="info"
              @click="addFirstSelectDy"
              >添加选项</el-button
            >
          </el-form-item>
          <div class="select-content-box">
            <div class="select-content">
              <div class="config-item" v-for="(i, j) in additionalProp1.config" :key="j">
                <div v-if="additionalProp1.config.length">
                  <div class="title-content">
                    <div style="width: 90px; height: 10px"></div>
                    <div class="fl title-item w160 left-text">{{ '界面名称' }}</div>
                    <div class="fl title-item w160 left-text">{{ '字段名称' }}</div>
                    <div class="fl title-item w50 left-text">{{ '界面排序' }}</div>
                  </div>
                </div>
                <el-form-item>
                  <span slot="label" style="color: red">*</span>
                  <span slot="label" style="font-weight: 700">选项{{ j + 1 }}：</span>
                  <el-input class="fl w160" type="input" :maxlength="30" placeholder="参数名称" v-model="i.text" />
                  <el-select
                    class="fl w160"
                    style="margin: 0 10px"
                    v-model="i.value"
                    @change="handleSelectCustomer(i.value, j)"
                    filterable
                    placeholder="请选择"
                  >
                    <el-option v-for="(k, l) in customerOption" :key="l" :label="k.text" :value="k.value"></el-option>
                  </el-select>
                  <!--  -->
                  <!-- <el-input
                      class="fl"
                      style="width: 100px; margin: 0 10px"
                      type="input"
                      :maxlength="30"
                      placeholder="参数值"
                      v-model="i.value"
                    /> -->
                  <el-input
                    class="fl"
                    style="width: 60px"
                    type="input"
                    :maxlength="30"
                    placeholder="排序"
                    v-model="i.orderNum"
                  />
                  <el-checkbox v-if="configForm.optionType === '1'" class="fl field-show" v-model="i.isShow"
                    >展示</el-checkbox
                  >
                  <span
                    @click="addSecondSelectDy(j)"
                    style="float: left; margin-left: 20px; cursor: pointer; color: #4fa1a4"
                    >添加文案</span
                  >
                  <span
                    v-if="configForm.optionType === '3'"
                    @click="delDyFirstSelect(j)"
                    style="float: left; margin-left: 20px; cursor: pointer; color: #4fa1a4"
                    >删除</span
                  >
                </el-form-item>
                <!-- <el-form-item class="field-radio">
                  <span slot="label" style="color: red">*</span>
                  <span slot="label">文案内容：</span>
                  <el-button size="small" icon="el-icon-plus" type="info" @click="addSecondSelectDy(j)"
                    >添加文案</el-button
                  >
                </el-form-item> -->
                <div style="background: #f2f2f2; padding: 10px 0; margin-bottom: 20px">
                  <el-form-item v-for="(k, l) in i.additionalList" :key="l">
                    <span slot="label" style="color: red">*</span>
                    <span slot="label">文案{{ l + 1 }}：</span>
                    <el-input class="fl w160" type="input" :maxlength="30" placeholder="参数名称" v-model="k.text" />
                    <el-input
                      class="fl w160"
                      style="margin: 0 10px"
                      type="input"
                      :maxlength="30"
                      placeholder="参数值"
                      v-model="k.value"
                    />
                    <el-input
                      class="fl"
                      style="width: 60px"
                      type="input"
                      :maxlength="30"
                      placeholder="排序"
                      v-model="k.orderNum"
                    />
                    <span
                      @click="delDySecondSelect(j, l)"
                      style="float: left; margin-left: 20px; cursor: pointer; color: #4fa1a4"
                      >删除</span
                    >
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 调研对象 end -->

        <!-- 提示文字 -->
        <div>
          <el-form-item>
            <span slot="label">提示文字：</span>
            <el-input
              style="width: 530px"
              class="fl"
              type="input"
              :maxlength="100"
              placeholder="请输入提示文案，便于用户理解"
              v-model="configForm.tipText"
            >
            </el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item v-if="configForm.fieldType == 'file' || configForm.fieldType == 'picture'">
            <span slot="label">
              <el-popover trigger="hover" width="300" placement="right-start">
                    <div>{{ '用于提供给终端服务人员在做任务时的参考图' }}</div>
                    <template slot="reference">
                      <i class="el-icon-question"></i>
                    </template> </el-popover
                  >
              示例图片：</span>
             <!-- 整改照片 -->
             <div class="dialogCon-describe file-list-box">
              <el-upload
                class="upload-file-box"
                action="#"
                :limit="5"
                :headers="token"
                :on-exceed="handleExceed"
                accept=".jpg,.png,.jpeg"
                :on-remove="handleBillRemove"
                :http-request="uploadBillImage"
                :file-list="configForm.pictUrl"
              >
                <div class="import-btn-tips">
                  <el-button size="mini" icon="el-icon-my-import" style="margin-bottom: 0" type="importNew"
                    >点击上传</el-button
                  >
                  <div slot="tip" class="import-step-tip"> 
                    {{ '最大不超过 5M 的图片，支持jpg、png、jpeg等图片格式' }}
                  </div>
                </div>
                <div slot="file" slot-scope="{ file }" v-show="false">

                </div>

              </el-upload>

              <div class="flex" v-for="file in configForm.pictUrl"  v-if="configForm.pictUrl && configForm.pictUrl.length > 0">
                <div class="file-name nowrap-ellipsis">{{ file.fileName }}</div>
                <div class="flex">
                  <a
                    @click="handlePictureCardPreview(file)"
                    style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                    download="FileName"
                    class="downFile"
                    >查看</a
                  >
                  <a
                    @click="handleBillRemove(file)"
                    style="text-decoration: underline; cursor: pointer; color: #4fa1a4; margin-left: 20px"
                    download="FileName"
                    class="downFile"
                    >删除</a
                  >
                </div>
              </div>
            </div>
              <!-- <div class="dialogCon-describe">
                <el-upload
                  style="display: flex"
                  action="#"
                  name="image"
                  list-type="picture-card"
                  :headers="token"
                  accept=".jpg,.png,.jpeg"
                  :limit="5"
                  :on-exceed="handleExceed"
                  :file-list="configForm.pictUrl"
                  :on-remove="handleBillRemove"
                  :http-request="uploadBillImage"
                  :on-preview="handlePictureCardPreview"
                >
                  <div slot="file" slot-scope="{ file }">
                    <img class="el-upload-list__item-thumbnail" :src="file.path" alt="" />
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span  class="el-upload-list__item-delete" @click="handleDownload(file)">
                        <i class="el-icon-download"></i>
                      </span>
                      <span class="el-upload-list__item-delete" @click="handleBillRemove(file)">
                        <i class="el-icon-delete"></i>
                      </span>
                      
                    </span>
                  </div>
                  <i slot="default" class="el-icon-plus"></i>
                  <template slot="default" slot-scope="{ file }">
                    
                    <span style="color:red">{{ file.name }}</span>
                  </template>
                  
                </el-upload>
                
              </div> -->
          </el-form-item>
        </div>
        <!-- 校验规则 -->
        <template
          v-if="configForm.fieldType == 'file' || configForm.fieldType == 'number' || configForm.fieldType == 'picture'"
        >
          <div class="title" style="padding-left: 20px">
            <span></span> 校验规则<i style="font-size: 12px; color: red; font-style: normal"
              >（注：类似【姓名】这种非数值文本不可配置）</i
            >
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item>
                <span slot="label"
                  ><el-popover trigger="hover" width="300" placement="right-start">
                    <div>{{ '例：最多不可超出7人，这里写【7】；' }}</div>
                    <template slot="reference">
                      <i class="el-icon-question"></i>
                    </template> </el-popover
                  >最大数量：</span
                >
                <!-- <el-input class="fl" style="width: 450px" oninput="this.value=this.value.toString().match(/^\d+(?:\d{0,3})?/)"
                  :maxlength="30" placeholder="例：最多不可超出7人，这里写【7】；" v-model="configForm.maxValue">
                </el-input> -->
                <div class="max-value">
                  <el-input-number
                    size="mini"
                    v-model="configForm.maxValue"
                    :min="0"
                    :max="99999999999999999999"
                    label="例：最多不可超出7人，这里写【7】；"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label"
                  ><el-popover trigger="hover" width="300" placement="right-start">
                    <div>{{ '例：图片最少要传2张，这里写【2】' }}</div>
                    <template slot="reference">
                      <i class="el-icon-question"></i>
                    </template> </el-popover
                  >最小数量：</span
                >
                <!-- <el-input class="fl" style="width: 450px" oninput="this.value=this.value.toString().match(/^\d+(?:\d{0,3})?/)"
                  :maxlength="30" placeholder="例：图片最少要传2张，这里写【2】" v-model="configForm.minValue">
                </el-input> -->
                <div class="max-value">
                  <el-input-number
                    size="mini"
                    v-model="configForm.minValue"
                    :min="0"
                    :max="99999999999999999999"
                    label="例：图片最少要传2张，这里写【2】"
                  ></el-input-number>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <span slot="label">拦截提示语：</span>
            <el-input
              class="fl"
              style="width: 530px"
              type="input"
              :maxlength="30"
              placeholder="例：至少需上传两张图哦～"
              v-model="configForm.interceptText"
            >
            </el-input>
          </el-form-item>
        </template>

     
         


        <!-- 单行/多行文本 校验规则 -->
        <template v-if="configForm.fieldType == 'input' || configForm.fieldType == 'text'">
          <div class="title" style="padding-left: 20px"><span></span>校验规则</div>
          <el-form-item class="field-radio">
            <!-- <span slot="label" style="color: white">*</span> -->
            <span slot="label"
              >不可输内容<el-tooltip
                class="item"
                effect="dark"
                content="仅可输入英文、中文、顿号"
                placement="right-start"
                ><i class="el-icon-question"></i></el-tooltip
              >：</span
            >
            <el-input
              style="width: 530px"
              type="textarea"
              :rows="5"
              placeholder="仅可输入英文、中文、顿号"
              v-model="configForm.errorKeyword"
              @input="configForm.errorKeyword = configForm.errorKeyword.replace(/[^\a-\z\A-\Z\、\u4E00-\u9FA5]/g, '')"
            >
            </el-input>
          </el-form-item>
        </template>
           <!-- 时长范围限制 -->
         <template v-if="configForm.fieldName=='visitDuration'&&configForm.fieldType=='duration'">
            <el-form-item class="field-radio">
              <span slot="label"><span slot="label" style="color: red">*</span>时长范围限制：</span>
              <el-radio-group @change="configForm.maxTime='';configForm.minTime=''" v-model="configForm.isLimitMin" :disabled="configForm.isSysField == 'Y'">
                <el-radio label="N">不限制</el-radio>
                <el-radio label="Y">
                   <span>限制，设置时长范围</span>
                   <el-select @change="configForm.isLimitMin='Y'" style="width: 100px; margin:0 10px" v-model="configForm.minTime" placeholder="请选择">
                      <el-option v-for="item in getCodeListByKey('时长')" :key="item.value" :label="item.text" :value="item.value">
                      </el-option>
                  </el-select>
                  <span>至</span>
                  <el-select @change="configForm.isLimitMin='Y'"  style="width: 100px; margin-left: 10px" v-model="configForm.maxTime" placeholder="请选择">
                      <el-option v-for="item in getCodeListByKey('时长')" :key="item.value" :label="item.text" :value="item.value">
                      </el-option>
                  </el-select>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="做任务时选择这里配置的【时长】范围"
                    placement="right-start"
                    ><i class="el-icon-question"></i></el-tooltip
                  >
                </el-radio>
              </el-radio-group>
            </el-form-item>
        </template>
        <!-- 时长范围限制 -->
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="$route.query.type!=3">
        <el-button size="mini" plain @click="visible = false">取 消</el-button>
        <el-button size="mini" type="info" v-if="isEdit" @click="sureModifyAlert">修改</el-button>
        <el-button size="mini" type="info" v-else @click="sureAlert">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择产品 -->
    <el-dialog title="选择产品" :visible.sync="dialogProduct" width="900px">
      <el-row :gutter="24" class="mb30">
        <el-col :span="13">
          <div class="search-area-div w80">产品名称：</div>
          <el-input v-model="pages.goodsName" class="ipt-sty" placeholder="请输入" clearable></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="mini" type="info" @click="getProduct(1)">搜索</el-button>
        </el-col>
        <el-col :span="3">
          <el-button size="mini" type="danger" @click="emptyProduct()">清空</el-button>
        </el-col>
      </el-row>
      <!-- <div class="product-select-all"><el-checkbox style="display:flex;align-items: center;" v-model="checkedAllProduct" @change="checkedAllProductChange">全选</el-checkbox></div> -->
      <el-table
        :data="productInformationList"
        style="width: 100%"
        :row-key="getRowKeys"
        border
        v-loading="loading"
        ref="dataTable"
        height="60vh"
        @select="handleSelectionChange"
        @select-all="handleSelectionChange"
        @row-click="handleRowClick"
      >
      <!-- @selection-change="handleSelectionChange" -->
        <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (pages.pageIndex - 1) * pages.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="goodsName" label="产品" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="product">
              <img class="product-img" :src="scope.row.pictContent | filterImgUrl" alt="" />
              <p class="product-text w247">{{ scope.row.goodsName }}</p>
            </div>
            <!-- <p class="select-tip" v-show="(isChangePrice == 0&&scope.row.priceType ==2)||(isChangePrice == 0&&scope.row.priceType ==1&&scope.row.price ==0)||(isChangePrice == 0&&scope.row.priceType ==1&&!scope.row.price)">无法加购，请联系运营是否需要支持自行填价</p> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsSpec"
          label="规格"
          header-align="center"
          align="left"
          width="170"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="producer"
          label="生产企业"
          header-align="center"
          align="center"
          width="170"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="price" label="单价" header-align="center" align="right" width="120">
          <template slot-scope="scope">
            <!-- 固定价 -->
            <span v-if="scope.row.priceType == '1' && scope.row.price !== 0 && scope.row.price">{{
              scope.row.price | numDigit | numFmt
            }}</span>
            <!-- 区间价 -->
            <span v-if="scope.row.priceType == '2'">
              {{ scope.row.price | numDigit | numFmt }}~{{ scope.row.maxPrice | numDigit | numFmt }}
            </span>
            <span v-if="scope.row.priceType == '1' && (scope.row.price == 0 || !scope.row.price)">未定价</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pages.pageIndex"
        :page-size="pages.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pages.totalRows"
      >
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <p class="t-left fl font-S14">本次已选择{{ multipleSelectionGoodsList.length }}个产品</p>
        <el-button plain size="mini" @click="dialogProduct = false">取消</el-button>
        <el-button size="mini" type="info" @click="submitFormProduct()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 库存图片查看 -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcLists" />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import  MarkingRuleConfig from './components/MarkingRuleConfig.vue';
import  GoodsShowRuleConfig from './components/GoodsShowRuleConfig.vue';
import  CompetitionRuleConfig from './components/CompetitionRuleConfig.vue';
import  ZbRuleConfig from './components/ZbRuleConfig.vue';
import  BhRuleConfig from './components/BhRuleConfig.vue';
import  ReRuleConfig from './components/ReRuleConfig.vue';
import  KcRuleConfig from './components/KcRuleConfig.vue';
import  CppsRuleConfig from './components/CppsRuleConfig.vue';
import  SsgtRuleConfig from './components/SsgtRuleConfig.vue';
import  ruleConfig from './mixins/ruleConfig.js';
import  store from '@/store';
export default {
  mixins:[ruleConfig],
  components: {
    ElImageViewer,
    MarkingRuleConfig,
    ZbRuleConfig,
    BhRuleConfig,
    KcRuleConfig,
    ReRuleConfig,
    CppsRuleConfig,
    SsgtRuleConfig,
    CompetitionRuleConfig,
    GoodsShowRuleConfig
  },
  filter: {},
  data() {
    return {
      // dialogImgVisible: false,//预览图片
      // dialogImageUrl:'',//预览图片地址
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      assignRadio: 0, // 人员自行指派客户给自己 0不允许自行指派 1允许自行指派
      subTitle:null,
      tableHeight: window.innerHeight - 330,
      checked: true,
      value: [],
      fullscreenLoading: false,
      textTitle: '字段配置',

      functionCode: '',
      functionName: '',
      functionDesc: '',
      guid: '',
      height: window.innerHeight - 260,
      right: 'right',
      fieldList: [],
      dialogVisible: false,
      sendTenantList: [],
      tenantList: [],
      tenantName: '',
      organisationGuid: '',
      organisationList: [],
      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      organisationNameList: '',
      areaData: [],
      delList: [],
      filterText: '',
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
        disabled: this.disabledTreeNode,
      },
      visible: false,
      configForm: {
        optionType: '', // 选项方式
        dictionaryName: '', // 字典名称
        fieldAlias: '', //界面名称
        fieldDesc: '',
        fieldName: '',
        fieldType: '',
        isSysField: 'N',
        formVisible: 'Y',
        isDetail: 'N',
        isRequired: 'Y',
        appSideType: '0',
        isUpdate:'Y',
        showPosition: [],
        selectItemList: [{ text: '', value: '', orderNum: '' }],
        errorKeyword: '',
        interceptText: '',
        tipText: '',
        guid: '',
        maxValue: null,
        extensionConfig: {
          additionalProp1: {
            config:[]
          },
        },
        minValue: null,
        pictUrl:[],//标准示例图
        isLimitMin:'N',
        maxTime:'',
        minTime:''
      },

      additionalProp1: {
        config: [
          {
            text: '',
            value: '',
            orderNum: '',
            additionalList: [
              {
                text: '',
                value: '',
                orderNum: '',
              },
            ],
          },
        ],
      },
      fieldTypeList: [
        {
          key: '文本',
          value: 'input',
        },
        {
          key: '数字',
          value: 'number',
        },
        {
          key: '多行文本',
          value: 'text',
        },
        {
          key: '单选项',
          value: 'radio',
        },
        {
          key: '多选项',
          value: 'mulRadio',
        },
        {
          key: '选择客户',
          value: 'chooseCustomer',
        },
        {
          key: '选择产品',
          value: 'chooseGoods',
        },
        {
          key: '选择科室',
          value: 'chooseKeShi',
        },
        {
          key: '选择区域',
          value: 'chooseArea',
        },
        {
          key: '选择流程',
          value: 'chooseFlow',
        },
        {
          key: '选择会议列表',
          value: 'chooseMeetingList',
        },
        {
          key: '定位',
          value: 'location',
        },
        {
          key: '附件',
          value: 'file',
        },
        {
          key: '月份',
          value: 'month',
        },
        {
          key: '客户类型',
          value: 'customerType',
        },
        {
          key: '时间',
          value: 'time',
        },
        {
          key: '日期',
          value: 'date',
        },
        {
          key: '图片',
          value: 'picture',
        },
        {
          key: '金额',
          value: 'amount',
        },
          {
          key: '选择时长',
          value: 'duration',
        },
      ],
      currentIndex: '',
      isEdit: false,
      fieldOptionList: [],
      kcLabelIndex: 0,
      kcRuleIndex: 0,
      kcSetType: 0,
      selectProduct: '',
      addConfig: [],
      delConfig: [],
      editConfig: [],
      selectDictionaryList: [], // !选中的字典op
      selectItemList: [], // !选中的字典itemlist
      //库存采集
      optionsKc: [
        {
          value: 'gt',
          label: '大于',
        },
        {
          value: 'lt',
          label: '小于',
        },
        {
          value: 'ge',
          label: '大于等于',
        },
        {
          value: 'le',
          label: '小于等于',
        },
        {
          value: 'gt_lt',
          label: '介于',
        },
        {
          value: 'eq',
          label: '等于',
        },
      ],
      optionsKcProductType: [
        {
          value: 'ALL',
          label: '全部产品',
        },
        {
          value: '',
          label: '部分产品',
        },
      ],
      dialogProduct: false, //产品弹框
      checkedAllProduct: false,
      loading: false,
      expiryDateList: [],
      stockNumList: [],
      productInformationList: [],
      pages: {
        pageIndex: 1,
        tenantGuid: '',
        pageSize: 10,
        goodsName: '',
        isPrescription: '',
        staffGuid: '',
        totalPage: 0,
        totalRows: 0,
      },
      multipleSelectionGoodsList: [],
      optionsProduct: [],
      value: '',
      kcList: [],
      kcList1: [],
      customerOption: [],
      queryCode: '', //路由code
      //市场调研可见权限配置
      radio: '',
      visitRadioList: [
        { name: '医院', competenceParam: 'CUSTOMER_GS', type: '4' },
        { name: '商业公司', competenceParam: 'CUSTOMER_GS', type: '2' },
        { name: '药店', competenceParam: 'CUSTOMER_GS', type: '1' },
        { name: '医生', competenceParam: 'CUSTOMER_GS', type: '33' },
        { name: '商业客户', competenceParam: 'CUSTOMER_GS', type: '10' },
        { name: '居间人', competenceParam: 'CUSTOMER_GS', type: '6' },
        { name: '其他', competenceParam: 'CUSTOMER_GS', type: '14' },
        { name: '药店联系人', competenceParam: 'CUSTOMER_GS', type: '15' },
      ],
      holidayRuleList:[],
      visitRadioListKey: [], // ! SQSH可见权限取客户类型字典的key
      showViewer: false, //库存图片预览
      url: require('../../assets/images/kc_pic.jpg'),
    };
  },
  async created() {
    if (this.$route.query.type == 0) {
      this.subTitle = '复制' + localStorage.threeLevels + '字段规则';
    } else if (this.$route.query.type == 1) {
      this.subTitle = '编辑' + localStorage.threeLevels + '字段规则';
    } else if (this.$route.query.type == 3) {
      //看日志
      this.subTitle = localStorage.threeLevels + '历史字段规则';
    } else {
      this.subTitle = '新增' + localStorage.threeLevels + '字段规则';
    }
    this.queryCode = this.$route.query.functionCode;
    if (this.queryCode == 'SDYZ'||this.queryCode == 'YWCL') {
      this.visitRadioList = [
        { name: '药店', competenceParam: 'CUSTOMER_GS', type: '1' },
      ];
    }
    if (this.queryCode == 'JPXXSJ') {
      this.visitRadioList = [
        { name: '医院', competenceParam: 'CUSTOMER_GS', type: '4' },
        { name: '商业公司', competenceParam: 'CUSTOMER_GS', type: '2' },
        { name: '药店', competenceParam: 'CUSTOMER_GS', type: '1' },
      ];
    }
    if (this.queryCode == 'ZBHZTJ') {
      this.visitRadioList = [{ name: '医院', competenceParam: 'CUSTOMER_GS', type: '4' }];
      this.bizParam1.dayEachPerson = {
        sameThenMax: null,
        eachThenMax: null,
        customerTypes: ['13'],
        enabled: false,
      };
      this.bizParam1.dayEachCustomerNotSame = {
        eachThenMax: null,
        customerTypes: ['4'],
        enabled: false,
      };
      this.bizParam1.monthSameCustomerItem = {
        sameThenMax: null,
        customerTypes: ['13'],
        enabled: false,
      };
      this.bizParam1.monthSameCustomer = {
        sameThenMax: null,
        customerTypes: ['4'],
        enabled: false,
      };
      console.log(this.bizParam1);
    }
    this.getTenantList();
    await this.getCustomerList();
    this.getSendTenantList();
    this.getOptionList();
    this.getConfig();
    this.getCodeList();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    specialOperations(val) {
      console.log(val, 'SCDY客户类型特殊操作标识');
      if (val) {
        this.getAdditionalProp();
        // this.additionalProp1.config.forEach(item=>{
        //   item.isShow = true
        // })
      }
    },
  },
  computed: {
    specialOperations() {
      // 判断是否SCDY特殊操作
      let flag = false;
      if (
        this.queryCode == 'SCDY' &&
        this.configForm.dictionaryName === '客户类型' &&
        this.configForm.optionType === '1'
      ) {
        flag = true;
      }
      return flag;
    },
    checkCPMX_disable() {
      // 产品明细展示位置的的禁用开关
      let fnCodeLK = {
        SCDY: true,
        TXL: true,
        YSJD: true,
      };
      let fieldDescLK = {
        goodsCode: true,
        goodsSpec: true,
        bigUnitQty: true,
        producer: true,
        goodsPrice: true,
      };
      let flag = false;
      if (
        fnCodeLK[this.queryCode] &&
        fieldDescLK[this.configForm.fieldName] &&
        this.editConfig.length &&
        this.editConfig[0].parameterValue == '关'
      ) {
        flag = true;
      }
      return flag;
    },
    dictionaryTypeList() {
      // 字典类型下拉框op
      let arr = [];
      // let codeList = localStorage.codeList ? JSON.parse(localStorage.codeList) : []
      this.codeList.forEach((item) => {
        arr.push({
          key: item.dictTypeName,
          value: item.guid,
        });
      });
      return arr;
    },
    haveRange() {
      // #新可见权限判断
      return (
        this.queryCode === 'SQSH' ||
        this.queryCode === 'THCL' ||
        this.queryCode === 'XFGL' ||
        this.queryCode === 'KCXXCJ' ||
        this.queryCode === 'CPPS' ||
        this.queryCode === 'HCSJRK' ||
        this.queryCode === 'SSGT' ||
        this.queryCode === 'HCPD' ||
        this.queryCode === 'CPXSTG' ||
        this.queryCode === 'HYLB' ||
        this.queryCode === 'BHRX' ||
        this.queryCode === 'BHOTC' ||
        this.queryCode === 'BHSY' ||
        this.queryCode === 'XSBF' 
      );
    },
    // 其他参数配置的tab
    activeName:{
      get(){
        if (this.showTab1) {
          return 'first'
        } else if (this.showTab4) {
          return 'four'
        } else if (this.showTab2) {
          return 'second'
        }else if (this.showTab5) {
          return 'five'
        } else if (this.showTab6) {
          return 'six'
        } else {
          return 'third'
        }
      },
      set(){}
    },
    showTab1() {
      // #其他参数配置显示判断
      return (
        this.queryCode === 'ZBHZTJ' ||
        this.queryCode === 'TKYL' ||
        this.queryCode === 'SCDY' ||
        this.queryCode === 'JPXXSJ' ||
        this.queryCode === 'SDYZ' ||
        this.queryCode === 'YWCL' ||
        this.queryCode === 'BHRX' ||
        this.queryCode === 'BHOTC' ||
        this.queryCode === 'BHSY' ||
        this.queryCode === 'SQSH' ||
        this.queryCode === 'CPPS' ||
        this.queryCode === 'HCSJRK' ||
        this.queryCode === 'SSGT' ||
        this.queryCode === 'THCL' ||
        this.queryCode === 'SWQT' ||
        this.queryCode === 'TSGL' ||
        this.queryCode === 'XCPPX' ||
        this.queryCode === 'ZTBXXCJ' ||
        this.queryCode === 'ZTBGWXXCJ' ||
        this.queryCode === 'SBWX' ||
        this.queryCode === 'SBAZ' ||
        this.queryCode === 'XFGL' ||
        this.queryCode === 'KCXXCJ' ||
        this.queryCode === 'HCPD' ||
        this.queryCode === 'CPXSTG' ||
        this.queryCode === 'HYLB'||
        this.queryCode == 'JDSYGS' ||
        this.queryCode == 'TZYDJD' ||
        this.queryCode == 'YYJD' ||
        this.queryCode == 'XSBF' ||
        this.queryCode == 'KHLH' 
        
      );
    },
    showTab2() {
      // #其他参数配置显示判断
      return (
        this.queryCode === 'SCDY'||
        this.queryCode === 'JPXXSJ'||
        this.queryCode === 'YWCL'||
        this.queryCode === 'ZBHZTJ'||
        this.queryCode == 'PYQFX' ||
        this.queryCode === 'BHSY' ||
        this.queryCode === 'BHOTC' ||
        this.queryCode === 'BHRX' ||
        this.queryCode === 'WDXSDD' ||
        this.queryCode === 'WDCGDD'||
        this.queryCode === 'KCXXCJ'||
        this.queryCode === 'FKSXSDD'||
        this.queryCode === 'FKSCGDD'||
        this.queryCode === 'CPPS'||
        this.queryCode === 'SSGT'
      );
    },
    showTab3() {
      // #其他参数配置显示判断
      return (
        this.queryCode === 'ZTBGWXXCJ' ||
        this.queryCode === 'ZTBXXCJ' ||
        this.queryCode === 'XCPPX' ||
        this.queryCode === 'THCL' ||
        this.queryCode === 'CPPS' ||
        this.queryCode === 'HCSJRK' ||
        this.queryCode === 'ZCXXSJ' ||
        this.queryCode === 'HYLB' ||
        this.queryCode === 'KCXXCJ' ||
        this.queryCode === 'PYQFX' ||
        this.queryCode === 'YWCL' ||
        this.queryCode === 'SDYZ' ||
        this.queryCode === 'CPXSTG' ||
        this.queryCode === 'TKYL' ||
        this.queryCode === 'SCDY' ||
        this.queryCode === 'SWQT' ||
        this.queryCode === 'TSGL' ||
        this.queryCode === 'SBAZ' ||
        this.queryCode === 'SBWX' ||
        this.queryCode === 'HCPD' ||
        this.queryCode === 'SQSH' ||
        this.queryCode === 'SSGT' ||
        this.queryCode === 'ZBHZTJ' ||
        this.queryCode === 'XFGL' ||
        this.queryCode === 'KHDK' ||
        this.queryCode === 'JPXXSJ' ||
        this.queryCode === 'KHLH'
      );
    },
    showTab4(){
      return this.queryCode === 'KCXXCJ'
    },
    showTab5(){
      return (
        this.queryCode === 'SCDY'||
        this.queryCode === 'ZBHZTJ'||
        this.queryCode == 'HYLB' ||
        this.queryCode == 'BHRX' ||
        this.queryCode == 'BHOTC' ||
        this.queryCode == 'BHSY' ||
        this.queryCode == 'KCXXCJ'
      )
    },
    showTab6(){
      return  ['BHSY', 'BHOTC', 'BHRX'].includes(this.queryCode)
    }
  },
  methods: {
    isUpdateChange(){
      this.configForm.selectItemList.forEach(item=>{
        item.type=null;
      })
    },
    /** 参考图片 上传相关 开始*/
    handleBillRemove(file) {
      let self = this;
      self.configForm.pictUrl.forEach(function (j, ind) {
        if (j.path == file.path) {
          self.configForm.pictUrl.splice(ind, 1);
        }
      });
    },
    uploadBillImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            var path = decodeURIComponent(res.data.data);
            
            var str = file.file.name;
            let lastDotIndex = str.lastIndexOf('.');
            if (lastDotIndex!== -1) {
                str = str.substring(0, lastDotIndex);
            }
            let item = {
              fileName: str,
              // name: file.file.name,
              // url: res.data.data,//用于小图展示
              path: res.data.data,
            };
            self.configForm.pictUrl.push(item);
            console.log('上传成功',self.configForm.pictUrl);
            
            self.$message.success('上传成功');
          } else {
            // self.pictContentList.splice(0, 1);
            self.configForm.pictUrl=JSON.parse(JSON.stringify(self.configForm.pictUrl))
            this.$nextTick(()=>{
              self.$forceUpdate()
            })
           
            self.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          self.$message.error(err);
        });
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件`);
    },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.path;
    //   this.dialogImgVisible = true;
    // },
    handlePictureCardPreview(file) {
      this.srcLists = this.configForm.pictUrl.map(e=> e.path);
      let index = this.srcLists.indexOf(file.path);
      if (index !== -1){
        this.srcLists=[file.path,...this.srcLists.slice(index + 1),...this.srcLists.slice(0, index)]
      }
      //设置 图片查看器 进行显示
      console.log('this.srcLists',this.srcLists,file);
      
      this.$forceUpdate();
      this.showViewer = true;
    },
    changeOrderRepeat(val){
      if(!val){
        this.$set(this.bizParam1.monthOrderSumProduct,'limitMax',null)
      }
    },
    changeDeclareGoodsType(val){
      if(val=='2'){
        // 判断批号是否显示
        let arr=this.fieldList.filter(item=>
          item.fieldName == 'lotNo')
        if(!arr||arr.length<1){
          this.$message.warning('按产品批号采集需配置产品批号');
        }
        if(arr.length>0&&arr[0].formVisible!='Y'){
          this.$message.warning('按产品批号采集需展示产品批号');
        }
        console.log('arr',arr,this.fieldList)
      }
    },
    preview(tenantGuid, organisationGuid) {
      let functionCode = this.$route.query.functionCode;
      let userName = '13900000001';
      const userPwd = '666666';
      let previewUrl;
      this.fullscreenLoading = true;
      this.api
        .get(`/${serverConfig.msConfigureService}/function-path/get/function-path?functionCode=${functionCode}`)
        .then((res) => {
          this.fullscreenLoading = false;
          if (!res.data.data) {
            this.$message.error('请先去维护预览路径');
            return;
          }
          previewUrl = `https://llscmtest.cs4pl.com/loginRoot?tenantGuid=${tenantGuid}&organisationGuid=${organisationGuid}&userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(
            res.data.data.formUrl,
          )}`;
          if (location.href.indexOf('https://scm-operation.csyaoly.com') > -1) {
            //生产1
            userName = '13900001026';
            previewUrl = `https://llscm.csyaoly.com/loginRoot?tenantGuid=${tenantGuid}&organisationGuid=${organisationGuid}&userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(
              res.data.data.formUrl,
            )}`;
          }
          if (location.href.indexOf('https://scm-operation.cs4pl.com') > -1) {
            //生产2
            userName = '13900001026';
            previewUrl = `https://llscm-pre.cs4pl.com/loginRoot?tenantGuid=${tenantGuid}&organisationGuid=${organisationGuid}&userName=${userName}&userPwd=${userPwd}&formUrl=${encodeURIComponent(
              res.data.data.formUrl,
            )}`;
          }
          window.open(location.origin + '/previewPage?previewUrl=' + encodeURIComponent(previewUrl));
        });
    },
    /**
     * 是否展示
     * @param {*} val
     */
    changeFormVisible(val) {
      // 如果是否,则将已有的 展示位置 字段清空
      if (val == 'N') {
        this.$set(this.configForm, 'showPosition', []);
      }
    },
    /**
     * 展示位置
     * @param {*} val
     */
    changeShowPosition(val) {
      // 如果是有值,则将已有的 是否展示 字段设置为 是
      if (val.length > 0) {
        this.$set(this.configForm, 'formVisible', 'Y');
      }
    },
    onPreview() {
      this.srcLists=[this.url]
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    changeSysVal(val) {
      if (val === 'customerType') {
        this.configForm.dictionaryName = '客户类型';
        this.changeDictionaryType(this.configForm.dictionaryName); // todo 获取字典的选项
        this.dictionaryTypeList.forEach((item) => {
          if (item.key !== '客户类型') {
            item.disabled = true;
          }
        });
      } else {
        this.changeDictionaryType(this.configForm.dictionaryName);
        this.dictionaryTypeList.forEach((item) => {
          item.disabled = false;
        });
      }
    },
    // todo 数据字典change
    changeDictionaryType(val) {
      let arr = [];
      this.selectItemList = []; // !清空字典op
      if (val) {
        this.selectDictionaryList = this.getCodeListByKey(val); // 获取字典
        if (!this.selectDictionaryList) return;
      }
      if (this.configForm.fieldType == 'customerType') {
        // todo 客户类型特殊处理
        this.customerOption.forEach((item, index) => {
          this.selectItemList.unshift({
            text: item.text,
            label: item.text,
            value: item.value,
            orderNum: this.customerOption.length - index,
            isShow: false,
          });
        });
      } else {
        if (this.configForm.optionType === '2') {
          // todo 标准选项2处理 (是否类型字段) 有历史选项
          if (Array.isArray(this.configForm.selectItemList) && this.configForm.selectItemList.length) {
            this.selectItemList = this.configForm.selectItemList;
          } else {
            for (let index = 0; index < 1; index++) {
              const item = this.selectDictionaryList[index];
              this.selectItemList.push({
                text: item.text,
                label: item.text,
                value: item.value,
                orderNum: index + 1,
                isShow: false,
              });
            }
          }
        } else {
          this.selectDictionaryList.forEach((item, index) => {
            this.selectItemList.push({
              text: item.text,
              label: item.text,
              value: item.value,
              orderNum: index + 1,
              isShow: false, // !默认全部不勾选
            });
          });
        }
      }
      // todo 显示配置字典的勾选状态
      if (val === this.InitialDictionaryName) {
        this.selectItemList.forEach((item, index) => {
          let itemSelect = this.configForm.selectItemList.find((itemSelect) => itemSelect.value === item.value);
          if (itemSelect) {
            item.text = itemSelect.text;
            item.label = item.label;
            item.value = itemSelect.value;
            item.orderNum = itemSelect.orderNum;
            item.isShow = itemSelect.isShow || false; // 添加勾选状态
          } else {
            item.isShow = false;
          }
        });
      }
    },
    getSelectList() {},
    // todo 选项方式change
    changeXXFS(val) {
      if (val === '1' && this.configForm.fieldType === 'customerType') {
        this.$set(this.configForm, 'dictionaryName', '客户类型');
      } else if (val === '2') {
        this.$set(this.configForm, 'dictionaryName', '');
        this.selectItemList = [];
      } else {
        this.$set(this.configForm, 'dictionaryName', '');
      }
      // if (val === '1' || val === '2') {
      // }
      // if (this.configForm.dictionaryName) {
      //   this.changeDictionaryType(this.configForm.dictionaryName)
      // }
    },
    // cameraChange(val) {
    //   if(val=='Y'){
    //     if(this.fieldList &&this.fieldList.length>0){
    //       this.fieldList.forEach(i=>{
    //         if(i.fieldType=='location'&&i.formVisible=='N'){
    //           this.$message.error('请先将签到位置字段设置为展示')
    //           this.$set(this.bizParam1,'isAddWaterMark','N')
              
    //           return
    //         }
    //       })
    //     }
        
    //   }
    //   this.$forceUpdate();
    //   console.log("水印", val,this.bizParam1.isAddWaterMark);
    // },
    signChange(val) {
      this.$forceUpdate();
      console.log("sign", val);
    },
    radioChange(val) {
      this.$forceUpdate();
      console.log(val);
    },
    handleSelectField(v) {
      let fieldOptionList = this.fieldOptionList;
      fieldOptionList.forEach((item) => {
        if (item.fieldDesc == v) this.configForm.fieldName = item.fieldName;
      });
    },
    handleSelectCustomer(val, index) {
      let name = '';
      let flg = true;
      let { configForm } = this;
      let { optionType, fieldType } = configForm;
      if (
        (optionType === '1' || optionType === '3') &&
        (fieldType === 'customerType' || fieldType === 'radio' || fieldType === 'mulRadio')
      ) {
        this.customerOption.forEach((i) => {
          // 客户类型字典特殊处理
          if (val == i.value) {
            name = i.text;
          }
        });
      } else if (optionType === '2') {
        this.selectDictionaryList.forEach((i) => {
          // 非客户类型字典
          if (val == i.value) {
            name = i.text;
          }
        });
      }
      let list = JSON.parse(JSON.stringify(this.selectItemList));
      let repeat = this.isRepeat(list);
      console.log(list, repeat);
      // list.forEach((m, index) => {
      //   if (val == m.value) {
      //     list.splice(index, 1)
      //   }
      // })
      // if (this.selectItemList.length > 1) {
      //   list.forEach(i => {
      //     if (val == i.value) {
      //       flg = false;
      //     }
      //   })
      // }
      if (repeat[0]) {
        this.$message.error('选项不能重复！');
        this.selectItemList[index].text = '';
        this.selectItemList[index].value = '';
      } else {
        this.selectItemList.forEach((i) => {
          if (val == i.value) {
            i.text = name;
          }
        });
      }
    },
    handleSelectCustomer2(val, index) {
      let name = '';
      let flg = true;
      this.customerOption.forEach((i) => {
        if (val == i.value) {
          name = i.text;
        }
      });
      let list = JSON.parse(JSON.stringify(this.additionalProp1.config));
      let repeat = this.isRepeat(list);
      console.log(list, repeat);
      if (repeat[0]) {
        this.$message.error('选项不能重复！');
        this.additionalProp1.config[index].text = '';
        this.additionalProp1.config[index].value = '';
      } else {
        this.additionalProp1.config.forEach((i) => {
          if (val == i.value) {
            i.text = name;
          }
        });
      }
    },
    isRepeat(arr) {
      let repeat = [];
      let hash = {};
      for (let item = 0; item < arr.length; item++) {
        if (hash[arr[item].value]) {
          //如果有重复则进去该判断
          repeat.push(arr[item].value); //将重复项加到数组中用于提示
        } else {
          hash[arr[item].value] = true;
        }
      }
      return repeat;
    },
    //获取客户对象列表
    getCustomerList() {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/dict/data/get-dict?functionCode=${this.queryCode}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.customerOption = res.data.data;
            let list = JSON.parse(JSON.stringify(res.data.data));
            list.forEach((item) => {
              item.name = item.text;
              item.type = item.value;
              item.competenceParam = 'CUSTOMER_GS';
            });
            self.visitRadioList = list;
            if(this.queryCode=='SCDY'||
              this.queryCode=='ZBHZTJ'||
              this.queryCode=='KCXXCJ'||
              this.queryCode=='BHRX'||
              this.queryCode=='BHSY'||
              this.queryCode=='BHOTC'){
              let arr = JSON.parse(JSON.stringify(res.data.data));
              arr.forEach((item) => {
                item.name = item.text;
                item.type = item.value;
                item.isCheckHoliday = true;
              });
              self.holidayRuleList=arr
              // 初始化采集日期规则列表
              let collectArr = JSON.parse(JSON.stringify(res.data.data));
              collectArr.forEach((item) => {
                item.name = item.text;
                item.type = item.value;
                item.isCheckHoliday = true;
              });
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    // 获取客户类型数据字典配置
    getCustomerListPromiese() {
      this.visitRadioListKey = [];
      return new Promise((resolve, reject) => {
        let self = this;
        self.api
          .get(`/${serverConfig.msSalesPerformService}/dict/data/get-dict?functionCode=${this.queryCode}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (this.haveRange) {
                if (Array.isArray(res.data.data)) {
                  res.data.data.forEach((item) => {
                    // todo 获取配置的key
                    this.visitRadioListKey.push(item);
                  });
                }
              }
              resolve(res.data.data);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    getOptionList() {
      let self = this;
      let req = {
        functionCode: this.queryCode,
      };
      self.api.get(`/${serverConfig.msConfigureService}/function/default-field-list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.fieldOptionList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //排序向下
    sortDownField(row, index) {
      this.fieldList.splice(index, 1);
      this.fieldList.splice(index + 1, 0, row);
    },
    //排序向上
    sortUpField(row, index) {
      this.fieldList.splice(index, 1);
      this.fieldList.splice(index - 1, 0, row);
    },
    // 新增确认
    sureAlert() {
      let configForm = this.configForm;
      if (configForm.fieldDesc == '') {
        this.$message.error('请填写字段名称');
        return;
      }
      if (configForm.fieldName == '' && this.editConfig.length && this.editConfig[0].parameterValue == '开') {
        this.$message.error('请填写字段编码');
        return;
      }
      if (configForm.fieldType == '') {
        this.$message.error('请填写字段类型');
        return;
      }
      if (configForm.formVisible == 'Y' && !configForm.showPosition.length) {
        this.$message.error('请选择展示位置');
        return;
      }
      if (
        (this.configForm.fieldType == 'radio' ||
          this.configForm.fieldType == 'mulRadio' ||
          this.configForm.fieldType == 'customerType') &&
        !(this.configForm.fieldName == 'visitObjectType' && this.queryCode !== 'SCDY')
      ) {
        try {
          // if (this.selectItemList.length == 0) {
          //   throw new Error('请填写选项内容');
          // }
          this.selectItemList.forEach((item) => {
            if (item.text == '') {
              throw new Error('请填写参数名称');
            }
            if (item.value == '') {
              throw new Error('请填写参数值');
            }
          });

          let showItemList = this.selectItemList.filter((item) => item.isShow);
          if (showItemList.length === 0 && this.configForm.optionType === '1') {
            throw new Error('请填勾选展示的字段');
          } else if (this.configForm.optionType === '1') {
            showItemList.forEach((item) => {
              // todo 勾选的存入配置中
              this.configForm.selectItemList.push({
                text: item.text,
                value: item.value,
                orderNum: item.orderNum,
                isShow: item.isShow,
              });
            });
          } else {
            this.selectItemList.forEach((item) => {
              // todo 勾选的存入配置中
              this.configForm.selectItemList.push({
                text: item.text,
                value: item.value,
                orderNum: item.orderNum,
                isShow: item.isShow,
                type: item.type,
              });
            });
          }
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      }
      // ! 清空选项内容
      if (
        this.configForm.fieldType != 'radio' &&
        this.configForm.fieldType !== 'mulRadio' &&
        this.configForm.fieldType != 'customerType'
      ) {
        this.selectItemList = [];
        this.configForm.dictionaryName = '';
        this.configForm.optionType = '';
        this.configForm.selectItemList = [];
      }
      if (this.configForm.fieldType != 'number' && this.configForm.fieldType != 'file' && this.configForm.fieldType != 'picture') {
        this.configForm.interceptText = '';
        this.configForm.maxValue = '';
        this.configForm.minValue = '';
      }
      if (this.configForm.fieldName == 'visitObjectType' && this.queryCode == 'SCDY') {
        try {
          // if (this.additionalProp1.config.length == 0) {
          //   throw new Error('请填写选项内容');
          // }
          this.additionalProp1.config.forEach((item) => {
            // !校验文案内容
            if (Array.isArray(item.additionalList)) {
              item.additionalList.forEach((extendItem) => {
                if (extendItem.text == '') {
                  throw new Error('请填写文案参数名称');
                }
                if (extendItem.value == '') {
                  throw new Error('请填写文案参数值');
                }
              });
            }
            if (item.text == '') {
              throw new Error('请填写选项参数名称');
            }
            if (item.value == '') {
              throw new Error('请填写选项参数值');
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      } else {
        this.additionalProp1.config = [];
      }
      if (this.configForm.fieldName == 'visitDuration' && this.queryCode == 'SCDY') {
        if (!this.configForm.isLimitMin) {
          this.$message.error('请选择时长范围限制');
          return;
        }
        if (this.configForm.isLimitMin == 'Y'&&(!this.configForm.maxTime||!this.configForm.minTime)) {
          this.$message.error('请选择时长范围');
          return;
        }
        console.log(this.configForm.maxTime)
        console.log(this.configForm.minTime)
        if (this.configForm.isLimitMin == 'Y'&&((Number(this.configForm.maxTime)<Number(this.configForm.minTime))||(this.configForm.maxTime==this.configForm.minTime))) {
          this.$message.error('请选择正确的时长范围');
          return;
        }
      }
      if (this.additionalProp1.config.length != 0) {
        this.configForm.extensionConfig.additionalProp1 = this.additionalProp1;
      }
      this.visible = false;

      // 如果是否展示的值是 否，提交的时候将展示位置给一个默认值(移动端-新增编辑页面)（因为移动端存储xxx_config的时候通过showPosition字段过滤了
      if (this.configForm.formVisible == 'N') {
        this.configForm['showPosition'] = ['1'];
        // this.configForm['showPosition'] = [];
      }
      this.fieldList.push(this.configForm);
    },
    // 修改确认
    sureModifyAlert() {
      let configForm = this.configForm;
      this.configForm.selectItemList = [];
      if (configForm.fieldDesc == '') {
        self.$message.error('请填写字段名称');
        return;
      }
      if (configForm.fieldName == '') {
        self.$message.error('请填写字段编码');
        return;
      }
      if (configForm.fieldAlias == '') {
        self.$message.error('请填写界面名称');
        return;
      }
      if (configForm.fieldType == '') {
        self.$message.error('请填写字段类型');
        return;
      }
      if (configForm.formVisible == 'Y' && !configForm.showPosition.length) {
        this.$message.error('请选择展示位置');
        return;
      }
      if (
        (this.configForm.fieldType == 'radio' ||
          this.configForm.fieldType == 'mulRadio' ||
          this.configForm.fieldType == 'customerType') &&
        !(this.configForm.fieldName == 'visitObjectType' && this.queryCode == 'SCDY')
      ) {
        try {
          // if (this.selectItemList.length == 0 && this.configForm.fieldName != 'stopReason') {
          //   throw new Error('请填写选项内容');
          // }
          this.selectItemList.forEach((item) => {
            if (item.text == '') {
              throw new Error('请填写参数名称');
            }
            if (item.value == '') {
              throw new Error('请填写参数值');
            }
          });
          let showItemList = this.selectItemList.filter((item) => item.isShow);
          if (showItemList.length === 0 && this.configForm.optionType === '1') {
            throw new Error('请填勾选展示的字段');
          } else if (this.configForm.optionType === '1') {
            showItemList.forEach((item) => {
              // todo 勾选的存入配置中
              this.configForm.selectItemList.push({
                text: item.text,
                value: item.value,
                orderNum: item.orderNum,
                isShow: item.isShow,
              });
            });
          } else {
            this.selectItemList.forEach((item) => {
              // todo 勾选的存入配置中
              this.configForm.selectItemList.push({
                text: item.text,
                value: item.value,
                orderNum: item.orderNum,
                isShow: item.isShow,
                type: item.type,
              });
            });
          }
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      }
      // ! 清空选项内容
      if (
        this.configForm.fieldType != 'radio' &&
        this.configForm.fieldType != 'mulRadio' &&
        this.configForm.fieldType != 'customerType'
      ) {
        this.selectItemList = [];
        this.configForm.dictionaryName = '';
        this.configForm.optionType = '';
        this.configForm.selectItemList = [];
      }
      if (this.configForm.fieldType != 'number' && this.configForm.fieldType != 'file'&& this.configForm.fieldType != 'picture') {
        this.configForm.interceptText = '';
        this.configForm.minValue = '';
      }
      /**
       * !根据选项方式有不同的取值逻辑
       * !选项方式1(optionType 1) 取isShow为true的选项
       * !自定义选项(optionType 3) 取所有选项
       */
      if (this.configForm.fieldName == 'visitObjectType' && this.queryCode == 'SCDY') {
        try {
          // if (this.additionalProp1.config.length == 0) {
          //   throw new Error('请填写选项内容');
          // }
          this.additionalProp1.config.forEach((item) => {
            // !校验文案内容
            if (Array.isArray(item.additionalList)) {
              item.additionalList.forEach((extendItem) => {
                if (extendItem.text == '') {
                  throw new Error('请填写文案参数名称');
                }
                if (extendItem.value == '') {
                  throw new Error('请填写文案参数值');
                }
              });
            }
            if (item.text == '') {
              throw new Error('请填写选项参数名称');
            }
            if (item.value == '') {
              throw new Error('请填写选项参数值');
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
      } else {
        this.additionalProp1.config = [];
      }
      if (this.configForm.fieldName == 'visitDuration' && this.queryCode == 'SCDY') {
        if (!this.configForm.isLimitMin) {
          this.$message.error('请选择时长范围限制');
          return;
        }
        if (this.configForm.isLimitMin == 'Y'&&(!this.configForm.maxTime||!this.configForm.minTime)) {
          this.$message.error('请选择时长范围');
          return;
        }
        console.log(this.configForm.maxTime<this.configForm.minTime)
        console.log(this.configForm.minTime)
        if (this.configForm.isLimitMin == 'Y'&&(Number(this.configForm.maxTime)<Number(this.configForm.minTime))) {
          this.$message.error('请选择正确的时长范围');
          return;
        }
      }
      if (this.additionalProp1.config.length != 0) {
        this.configForm.extensionConfig.additionalProp1 = this.additionalProp1;
      }
      this.visible = false;

      // 如果是否展示的值是 否，提交的时候将展示位置给一个默认值(移动端-新增编辑页面)
      if (this.configForm.formVisible == 'N') {
        this.configForm['showPosition'] = ['1'];
        // this.configForm['showPosition'] = [];
      }
      this.fieldList[this.currentIndex] = this.configForm;
      let fieldList = this.fieldList;
      this.fieldList = [];
      setTimeout(() => {
        this.fieldList = fieldList;
      }, 50);
      this.$forceUpdate();

      // console.log(this.fieldList[this.currentIndex])
      // console.log(this.fieldList)
    },
    //去设置 停线原因 (停线申请)
    toSetting() {
      if (this.tenantName == '') {
        this.$message.error('请选择应用公司');
        return;
      }
      let tenantGuid;
      this.sendTenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          tenantGuid = item.guid;
        }
      });
      this.$router.push({
        path: 'lineStopRuleList',
        query: {
          tenantGuid,
          organisationGuid: this.organisationGuid,
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    //新增选项（非调研对象）
    addSelect() {
      this.selectItemList.unshift({ text: '', value: '', orderNum: '' });
    },
    //新增选项（调研对象）
    addFirstSelectDy() {
      this.additionalProp1.config.unshift({
        text: '',
        value: '',
        orderNum: '',
        additionalList: [],
      });
    },
    //新增文案选项
    addSecondSelectDy(index) {
      this.additionalProp1.config[index].additionalList.unshift({
        text: '',
        value: '',
        orderNum: '',
      });
    },
    delSelect(index) {
      this.selectItemList.splice(index, 1);
    },
    delDyFirstSelect(index) {
      this.additionalProp1.config.splice(index, 1);
    },
    delDySecondSelect(j, l) {
      this.additionalProp1.config[j].additionalList.splice(l, 1);
    },
    addFieldConfig() {
      this.visible = true;
      this.currentIndex = '';
      this.isEdit = false;
      this.textTitle = '新增字段';
      this.configForm = {
        isLimitMin:'N',
        minTime:'',
        maxTime:'',
        fieldAlias: '',
        fieldDesc: '',
        fieldName: '',
        fieldType: '',
        isSysField: 'N',
        formVisible: 'Y',
        isDetail: 'N',
        isRequired: 'Y',
        appSideType: '0',
        isUpdate:'Y',
        selectItemList: [],
        interceptText: '',
        tipText: '',
        maxValue: '',
        minValue: '',
        showPosition: [],
        extensionConfig: {
          additionalProp1: {
            config:[]
          },
        },
      };
      this.additionalProp1.config = [];
    },
    // todo 编辑字段
    editFieldConfig(detail, index,textTitle) {
      console.log(detail);
      // 如果不展示，显示的时候清空展示位置
      if(detail.formVisible=='N'){
        detail.showPosition=[]
      }
      this.visible = true;
      this.currentIndex = index;
      this.isEdit = true;
      this.textTitle = textTitle;
      this.InitialDictionaryName = detail.dictionaryName; // 初始字典名称
      this.configForm = {
        optionType: detail.optionType,
        dictionaryName: detail.dictionaryName,
        fieldDesc: detail.fieldDesc,
        fieldName: detail.fieldName,
        fieldType: detail.fieldType,
        isSysField: detail.isSysField,
        formVisible: detail.formVisible,
        isDetail: detail.isDetail,
        isRequired: detail.isRequired,
        appSideType: detail.appSideType,
        isUpdate:detail.isUpdate||'Y',
        selectItemList: detail.selectItemList,
        errorKeyword: detail.errorKeyword,
        interceptText: detail.interceptText,
        tipText: detail.tipText,
        guid: detail.guid,
        maxValue: detail.maxValue,
        minValue: detail.minValue,
        fieldAlias: detail.fieldAlias,
        showPosition:
          detail.showPosition && detail.showPosition.constructor === String
            ? detail.showPosition.split(',')
            : detail.showPosition.length > 0
            ? detail.showPosition
            : [],
        pictUrl:detail.pictUrl||[],
        isLimitMin:detail.isLimitMin||'N',
        minTime:detail.minTime?String(detail.minTime):null,
        maxTime:detail.maxTime?String(detail.maxTime):null,

      };
      
      this.showDictionaryInfo(); // todo 显示配置字典的勾选状态
      if (detail.fieldType === 'customerType' && detail.dictionaryName === '客户类型') {
        // todo 客户类型特殊处理
        this.dictionaryTypeList.forEach((item) => {
          if (item.key !== '客户类型') {
            item.disabled = true;
          }
        });
      } else {
        this.dictionaryTypeList.forEach((item) => {
          item.disabled = false;
        });
      }
      // 如果是否展示的值是 否，那么编辑的时候将展示位置的值清空
      if (detail.extensionConfig) {
        // !客户类型扩展字段处理
        this.additionalProp1 = detail.extensionConfig.additionalProp1;
        this.configForm.extensionConfig = detail.extensionConfig;
        if (this.queryCode == 'SCDY' && detail.dictionaryName === '客户类型' && detail.optionType === '1') {
          this.getAdditionalProp();
        }
      } else {
        this.additionalProp1 = {
          config: [],
        };
        this.configForm.extensionConfig = null;
      }

      // if (detail.extensionConfig) {
      //   this.additionalProp1 = detail.extensionConfig.additionalProp1;
      //   this.configForm.extensionConfig = detail.extensionConfig;
      // } else {
      //   this.additionalProp1 = {
      //     config: [],
      //   };
      //   this.configForm.extensionConfig = null;
      // }
    },
    // todo 显示配置字典的勾选状态
    showDictionaryInfo() {
      let { configForm } = this;
      if (configForm.dictionaryName) {
        this.changeDictionaryType(configForm.dictionaryName); // todo 获取字典的选项
      } else {
        this.selectItemList = configForm.selectItemList; // !选项列表赋值
      }
    },
    // todo 数组对比
    getChangeData(oldData, newData, key) {
      let delData = oldData.filter((item2) => !newData.some((item1) => item2[key] === item1[key]));
      let addData = newData.filter((item2) => !oldData.some((item1) => item2[key] === item1[key]));
      let changeData = {
        delData,
        addData,
      };
      return changeData;
    },
    getAdditionalProp() {
      // 添加其他配置项
      if (Array.isArray(this.additionalProp1.config) && Array.isArray(this.customerOption)) {
        // ! SCDY 客户类型特殊处理
        let changeData = this.getChangeData(this.additionalProp1.config, this.customerOption, 'value');
        console.log(changeData, 'changeData');
        changeData.addData.forEach((item) => {
          this.additionalProp1.config.push({
            value: item.value,
            text: item.text,
            orderNum: item.orderNum,
            additionalList: [
              /*   {
                  text: '请填写内容',
                  value: '1',
                  orderNum: '',
                }, */
            ],
          });
        });
      }
    },
    delVFieldConfig(index) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.fieldList.splice(index, 1);
        });
    },
    getFieldType(type) {
      let fieldTypeList = this.fieldTypeList;
      let key;
      fieldTypeList.forEach((item) => {
        if (item.value == type) {
          key = item.key;
        }
      });
      return key;
    },
    //库存采集-添加标签
    addLabel(type) {
      if (!this.tenantName) {
        this.$message.error('请先选择应用公司');
        return;
      }
      let tenantGuid = this.tenantGuid;
      this.sendTenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          tenantGuid = item.guid;
        }
      });
      this.getProduct('', tenantGuid);
      //数量
      if (type == 1) {
        let obj = {
          tag: '',
          rule: [
            {
              selectItems: 'ALL',
              selectName: 'ALL',
              selectNum: 0,
              ruleConfigType: '',
              value1: '',
              value2: '',
            },
          ],
        };
        this.stockNumList.push(obj);
      } else {
        //有效期
        let item = {
          tag: '',
          rule: [
            {
              selectItems: 'ALL',
              selectName: 'ALL',
              selectNum: 0,
              ruleConfigType: '',
              value1: '',
              value2: '',
            },
          ],
        };
        this.expiryDateList.push(item);
        console.log(this.expiryDateList);
      }
      this.multipleSelectionGoodsList = [];
      if (this.productInformationList && this.productInformationList.length > 0) {
        this.productInformationList.forEach((i) => {
          this.$nextTick(() => {
            this.$refs.dataTable.toggleRowSelection(i, false);
          });
        });
      }
      this.$message.success('添加成功，请至滑动至底部配置');
    },
    //库存采集-添加规则
    addRule(index, type) {
      if (type == 1) {
        let obj = {
          selectItems: 'ALL',
          selectName: 'ALL',
          selectNum: 0,
          ruleConfigType: '',
          value1: '',
          value2: '',
        };
        this.stockNumList[index].rule.push(obj);
      } else {
        let item = {
          selectItems: 'ALL',
          selectName: 'ALL',
          selectNum: 0,
          ruleConfigType: '',
          value1: '',
          value2: '',
        };
        console.log(this.expiryDateList);
        this.expiryDateList[index].rule.push(item);
      }
      this.multipleSelectionGoodsList = [];
    },
    delLabel(index, type) {
      if (type == 1) {
        this.stockNumList.splice(index, 1);
      } else {
        this.expiryDateList.splice(index, 1);
      }
    },
    delRule(index, index1, type) {
      if (type == 1) {
        this.stockNumList[index].rule.splice(index1, 1);
      } else {
        this.expiryDateList[index].rule.splice(index1, 1);
      }
    },
    //库存-判断是否是所有商品
    changeSelectNameSelect(item, index, index1, type) {
      this.multipleSelectionGoodsList = [];
      //库存数
      if (type == 1) {
        this.stockNumList[index].rule[index1].selectNum = 0;
        // this.stockNumList[index].rule[index1].selectName = '';
        if (item.selectName == 'ALL') {
          this.stockNumList[index].rule[index1].selectItems = 'ALL';
        } else {
          this.stockNumList[index].rule[index1].selectItems = '';
        }
      } else {
        this.expiryDateList[index].rule[index1].selectNum = 0;
        // this.expiryDateList[index].rule[index1].selectName = '';
        if (item.selectName == 'ALL') {
          this.expiryDateList[index].rule[index1].selectItems = 'ALL';
        } else {
          this.expiryDateList[index].rule[index1].selectItems = '';
        }
      }
    },
    //库存-选择产品
    async changeSelect(item, index, index1, type) {
      await this.getProduct(2);
      this.dialogProduct = true;
      console.log('kk',item);
      
      this.kcLabelIndex = index;
      this.kcRuleIndex = index1;
      this.kcSetType = type == 1 ? 1 : 0;
      if (this.productInformationList && this.productInformationList.length > 0) {
        this.productInformationList.forEach((i) => {
          this.$nextTick(() => {
            this.$refs.dataTable.toggleRowSelection(i, false);
            this.$refs.dataTable.clearSelection()
          });
        });
      }
      if (item.selectName !== 'ALL' && item.selectItems && item.selectItems !== 'ALL') {
        this.multipleSelectionGoodsList = item.selectItems.split(',');
        this.multipleSelectionGoodsList.forEach((i) => {
          this.productInformationList.forEach((j) => {
            if (i == j.guid) {
              this.$nextTick(() => {
                this.$refs.dataTable.toggleRowSelection(j, true);
              });
            }
          });
        });
      }
    },
    getRowKeys(row) {
      return row.guid;
    },
    //获取产品数据
    getProduct(type, tenantGuid) {
      let self = this;
      return new Promise((resolve, reject) => {
        self.loading = true;
        self.productInformationList = [];
        self.pages.tenantGuid = tenantGuid || this.tenantGuid;
        self.pages.staffGuid = JSON.parse(localStorage.userInfo).staffGuid;
        if (type == 1) {
          self.pages.pageIndex = 1;
        }
        if (type == 2) {
          self.pages.pageIndex = 1;
          this.pages.goodsName = '';
        }
        if (!self.pages.tenantGuid) return;
        self.api.postJson(`/${serverConfig.msProductService}/goods/data/get`, self.pages).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res.data);
            self.loading = false;
            self.productInformationList = res.data.data.records;
            self.pages.totalPage = res.data.data.totalPages;
            self.pages.totalRows = res.data.data.totalRows;
            
            
            if (self.productInformationList != null) {
              self.$nextTick(() => {
                self.productInformationList.forEach((item, index) => {
                  if (self.multipleSelectionGoodsList != null && self.multipleSelectionGoodsList.length > 0) {
                    self.multipleSelectionGoodsList.forEach((i) => {
                      if (item.guid == i) {
                        self.$refs.dataTable.toggleRowSelection(item, true);
                      }
                    });
                  }
                });
              });
            }
            resolve();
            console.log(self.productInformationList);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    emptyProduct() {
      this.pages.goodsName = '';
      this.getProduct(1);
    },
    //库存-产品提交
    submitFormProduct() {
      if (this.multipleSelectionGoodsList && this.multipleSelectionGoodsList.length > 0) {
        //有效期
        if (this.kcSetType == 0) {
          console.log(this.expiryDateList);
          this.expiryDateList[this.kcLabelIndex].rule[this.kcRuleIndex].selectNum =
            this.multipleSelectionGoodsList.length;
          this.expiryDateList[this.kcLabelIndex].rule[this.kcRuleIndex].selectItems =
            this.multipleSelectionGoodsList.join(',');
        } else {
          console.log(this.stockNumList);
          this.stockNumList[this.kcLabelIndex].rule[this.kcRuleIndex].selectNum =
            this.multipleSelectionGoodsList.length;
          this.stockNumList[this.kcLabelIndex].rule[this.kcRuleIndex].selectItems =
            this.multipleSelectionGoodsList.join(',');
        }
      } else {
        //有效期
        if (this.kcSetType == 0) {
          console.log(this.expiryDateList);
          this.expiryDateList[this.kcLabelIndex].rule[this.kcRuleIndex].selectNum = 0;
          this.expiryDateList[this.kcLabelIndex].rule[this.kcRuleIndex].selectItems = '';
          console.log(this.stockNumList);
        } else {
          this.stockNumList[this.kcLabelIndex].rule[this.kcRuleIndex].selectNum = 0;
          this.stockNumList[this.kcLabelIndex].rule[this.kcRuleIndex].selectItems = '';
        }
      }
      this.dialogProduct = false;
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    handleSizeChange1(val) {
      let self = this;
      self.pages.pageSize = val;
      this.getProduct();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.pages.pageIndex = val;
      this.getProduct();
    },
    //去重
    fn2(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.guid) && res.set(arr.guid, arr.guid));
    },
    // 产品多选
    handleSelectionChange(list) {
      let selectList = [];
      let productInformationList = []
      let otherList = [];
      if (list && list.length > 0) {
        list.forEach((i) => {
          selectList.push(i.guid);
        });
      }
      this.productInformationList.forEach(i => {
        productInformationList.push(i.guid);
      })
      this.multipleSelectionGoodsList.forEach(i => {
        if (productInformationList.indexOf(i) == -1) {
          otherList.push(i);
        }
      })
      this.multipleSelectionGoodsList = Array.from(new Set(selectList.concat(otherList)));
    },
    ruleChange(val, index, index1, type) {
      //为库存数时
      if (type == 1) {
        if (val == 'gt_lt') {
          this.stockNumList[index].rule[index1].value1 = '';
          this.stockNumList[index].rule[index1].value2 = '';
        } else {
          this.stockNumList[index].rule[index1].value1 = '';
        }
      } else {
        if (val == 'gt_lt') {
          this.expiryDateList[index].rule[index1].value1 = '';
          this.expiryDateList[index].rule[index1].value2 = '';
        } else {
          this.expiryDateList[index].rule[index1].value1 = '';
        }
      }
    },
    //判断库存开始天数
    kcStartChange(item, index, index1, type) {
      if (type == 1) {
        if (!/^[0-9]\d*$/.test(item.value1) && item.value1) {
          this.$message.error('请输入正确的数值格式');
          this.stockNumList[index].rule[index1].value1 = '';
          return;
        }
        if (Number(item.value1) >= Number(item.value2) && item.value2) {
          this.$message.error('开始数值不能大于结束数值');
          this.stockNumList[index].rule[index1].value1 = '';
          return;
        }
      } else {
        if (!/^[0-9]\d*$/.test(item.value1) && item.value1) {
          this.$message.error('请输入正确的数值格式');
          this.expiryDateList[index].rule[index1].value1 = '';
          return;
        }
        console.log(item);
        if (Number(item.value1) >= Number(item.value2) && item.value2) {
          this.$message.error('开始数值不能大于结束数值');
          this.expiryDateList[index].rule[index1].value1 = '';
          return;
        }
      }
    },
    //判断库存结束天数
    kcEndChange(item, index, index1, type) {
      console.log(item);
      if (type == 1) {
        if (!/^[1-9]\d*$/.test(item.value2) && item.value2) {
          this.$message.error('请输入正确的数值格式');
          this.stockNumList[index].rule[index1].value1 = '';
          return;
        }
        if (Number(item.value1) >= Number(item.value2) && item.value1) {
          this.$message.error('结束数值不能小于开始数值');
          this.stockNumList[index].rule[index1].value2 = '';
          return;
        }
      } else {
        if (!/^[1-9]\d*$/.test(item.value2) && item.value2) {
          this.$message.error('请输入正确的数值格式');
          this.expiryDateList[index].rule[index1].value2 = '';
          return;
        }
        if (Number(item.value1) >= Number(item.value2) && item.value1) {
          this.$message.error('结束数值不能小于开始数值');
          this.expiryDateList[index].rule[index1].value2 = '';
          return;
        }
      }
    },
    radioChange(val) {
      this.$forceUpdate();
      console.log(val);
    },
    // 下拉框全选功能
    selectAll() {
      if (this.value.length < this.dataArray.length) {
        this.value = [];
        this.dataArray.map((item) => {
          this.value.push(item);
        });
        this.value.unshift('全选');
      } else {
        this.value = [];
      }
    },
    radioChange(val) {
      this.$forceUpdate();
      console.log(val);
    },
    getDetailPromiese() {
      return new Promise((resolve, reject) => {
        this.fullscreenLoading = true
        let self = this;
        let functionCode = this.queryCode;
        let req = {
          guid: this.$route.query.guid,
          functionGuid: this.$route.query.functionGuid,
          functionCode: functionCode,
        };
        let path = `/${serverConfig.msConfigureService}/function/function-tenant-field/detail`;
        let reqMethod = 'postJson';
        if (this.$route.query.logGuid) {
          path = `/${serverConfig.msConfigureService}/function/get-change-history-detail`;
          reqMethod = 'get'
          req = {
            guid :this.$route.query.logGuid
          }
        }
        self.api[reqMethod](path, req)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if(this.$route.query.type == 3){
                res.data.data.fieldList  = res.data.data.beforeUpdateInfo.fieldList;
                res.data.data.tenantName  = res.data.data.beforeUpdateInfo.tenantName;
                res.data.data.tenantGuid  = res.data.data.beforeUpdateInfo.tenantGuid;
                res.data.data.organisationGuid  = res.data.data.beforeUpdateInfo.organisationGuid;
                res.data.data.bizParam = res.data.data.beforeUpdateInfo.bizParam;
              }
              self.fieldList = res.data.data.fieldList;
              if (this.$route.query.type == 1||this.$route.query.type == 3) {
                self.tenantName = res.data.data.tenantName;
                self.tenantGuid = res.data.data.tenantGuid;
                self.organisationGuid = res.data.data.organisationGuid && res.data.data.organisationGuid[0];
                self.getOrganisation(self.tenantGuid);
              }
              if (res.data.data.bizParam) {
                self.getProduct('', self.tenantGuid);
                self.bizParam1 = res.data.data.bizParam;
                self.bizParam1.isFastAdd = self.bizParam1.isFastAdd ? self.bizParam1.isFastAdd : 'Y';
                self.bizParam1.isChangePrice = self.bizParam1.isChangePrice || '0';
                self.bizParam1.declareGoodsType?self.bizParam1.declareGoodsType=self.bizParam1.declareGoodsType:self.$set(self.bizParam1,'declareGoodsType','1')
                self.bizParam1.orderState = self.bizParam1.orderState || '50';
                self.bizParam1.isOnlyCamera = self.bizParam1.isOnlyCamera? "Y":"N";
                self.bizParam1.isAddWaterMark = self.bizParam1.isAddWaterMark? "Y":"N";
                if(self.bizParam1.signLocation){
                  self.bizParam1.signLocation.allowOutside = self.bizParam1.signLocation.allowOutside? "Y":"N";
                }else{
                  self.bizParam1.signLocation={
                    // 签到位置
                    maxRadius: 2000,
                    allowOutside:'Y'
                  }
                }
                console.log('bizparam',self.bizParam1);
                
                    // #一客多人配置
                if (res.data.data.bizParam.allowAllocateSelf) {
                  this.assignRadio = 1;
                } else {
                  this.assignRadio = 0;
                }
               
                
                // #可见权限配置列表
                if (Array.isArray(self.bizParam1.visitRadioList) && self.bizParam1.visitRadioList.length) {
                  self.visitRadioList = self.bizParam1.visitRadioList;
                  if (!self.visitRadioList.find((item) => item.type === '14') && functionCode == 'SCDY') {
                    self.visitRadioList.push({ competenceParam: 'CUSTOMER_GS', name: '其他', type: '14',isIntercept: false });
                  }
                  if (!self.visitRadioList.find((item) => item.type === '15') && functionCode == 'SCDY') {
                    self.visitRadioList.push({ competenceParam: 'CUSTOMER_GS', name: '药店联系人', text: "药店联系人", type: "15", value: "15",isIntercept: false });
                  }
                  // if (functionCode === 'SQSH') {
                  //   let arr = [];
                  //   self.bizParam1.visitRadioList.forEach((item) => {
                  //     if (this.visitRadioListKey[item.type]) {
                  //       arr.push(item);
                  //     }
                  //   });
                  //   self.visitRadioList = [...arr];
                  // }
                  if(functionCode == 'YWCL'||functionCode == 'SDYZ'){
                    let obj = self.visitRadioList.find((item) => item.type === '1')
                    self.visitRadioList = [obj];
                  }
                  if (functionCode == 'JPXXSJ') {
                    // self.visitRadioList = self.bizParam1.visitRadioList.slice(0, 2); //历史数据，发版要刷
                  }
                  if (functionCode == 'ZBHZTJ') {
                    self.visitRadioList = self.bizParam1.visitRadioList.slice(0, 1);
                  }
                  if (functionCode == 'KHLH') {
                    // self.visitRadioList = self.visitRadioList//历史数据，发版要刷
                  }
                }
                // #节假日配置列表
                if (Array.isArray(self.bizParam1.holidayRuleList) && self.bizParam1.holidayRuleList.length) {
                  self.holidayRuleList = self.bizParam1.holidayRuleList;
                }
               
                if (functionCode == 'KCXXCJ') {
                  self.expiryDateList = self.bizParam1.expiryDate ? self.bizParam1.expiryDate : [];
                  self.stockNumList = self.bizParam1.stockNum ? self.bizParam1.stockNum : [];
                  self.bizParam1.isKcShow = res.data.data.bizParam.isKcShow ? res.data.data.bizParam.isKcShow : 'N';
                }
                if (functionCode == 'SCDY' && self.bizParam1.selectItemNum && self.bizParam1.selectItemNum.ruleItemList && self.bizParam1.selectItemNum.ruleItemList.length) {
                  let newRuleItemList = [];
                  self.bizParam1.selectItemNum.ruleItemList.forEach(item => {
                    newRuleItemList.push(item.customerType)
                  })
                  self.bizParam1.selectItemNum.ruleItemList = newRuleItemList;
                }
                if ((functionCode == 'SCDY'||functionCode == 'JPXXSJ') && self.bizParam1.monthCustomerSameSum && self.bizParam1.monthCustomerSameSum.ruleItemList && self.bizParam1.monthCustomerSameSum.ruleItemList.length) {
                  self.bizParam1.monthCustomerSameSum.ruleItemList.forEach(item => {
                    item.isSamePersonExecute = item.isSamePersonExecute =='Y'?true:false
                  })
                }
         
                if ((!self.bizParam1.dayBizDataSum)||
                (functionCode == 'ZBHZTJ' && !self.bizParam1.dayItemBelongSameCustomer&&!self.bizParam1.diyDayItemBelongSameCustomer) || 
                (functionCode == 'SCDY' && 
                (!(self.bizParam1.selectItemNum && self.bizParam1.selectItemNum.ruleItemList.length)&&
                !(self.bizParam1.dayItemBelongSameCustomer && self.bizParam1.dayItemBelongSameCustomer.ruleItemList.length)&&
                !(self.bizParam1.diyDayItemBelongSameCustomer && self.bizParam1.diyDayItemBelongSameCustomer.ruleItemList.length)&&
                !(self.bizParam1.dayItemSum && self.bizParam1.dayItemSum.ruleItemList.length)&&
                !(self.bizParam1.dayCustomerSumAndSame && self.bizParam1.dayCustomerSumAndSame.ruleItemList.length)&&
                !(self.bizParam1.monthItemSameSum && self.bizParam1.monthItemSameSum.ruleItemList.length)&&
                !(self.bizParam1.monthCustomerSameSum && self.bizParam1.monthCustomerSameSum.ruleItemList.length)))) {
                  //规则1重置
                  this.bizParam1.selectItemNum = {
                    "enabled": false,
                    "limitMax": null,
                    "ruleItemList": []
                  }
                  //规则2重置
                  this.bizParam1.dayItemBelongSameCustomer = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": functionCode == 'ZBHZTJ'? "13":'3',
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "10",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      // {
                      //   "enabled": false,
                      //   "customerType": "11",
                      //   "sameLimitMax": null,
                      //   "sumLimitMax": null
                      // }
                    ]
                  }
           
                  //规则3重置
                  this.bizParam1.dayItemSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "3",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "10",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "11",
                        "sumLimitMax": null
                      }
                    ]
                  }
                  //规则4重置
                  this.bizParam1.dayCustomerSumAndSame = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "1",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "2",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "4",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "14",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      }
                    ]
                  }
                  //规则5重置
                  this.bizParam1.monthItemSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": functionCode == 'ZBHZTJ'? "13":'3',
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "10",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "11",
                        "sumLimitMax": null
                      }
                    ]
                  }
                  //规则6重置
                  this.bizParam1.monthCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "4",
                        "sumLimitMax": null,
                        "isSamePersonExecute":null
                      },
                      {
                        "enabled": false,
                        "customerType": "1",
                        "sumLimitMax": null,
                        "isSamePersonExecute":null
                      },
                      {
                        "enabled": false,
                        "customerType": "2",
                        "sumLimitMax": null,
                        "isSamePersonExecute":null
                      },
                    
                      {
                        "enabled": false,
                        "customerType": "14",
                        "sumLimitMax": null,
                        "isSamePersonExecute":null
                      }
                    ]
                  }
                  //规则7
                  this.bizParam1.dayCustomerSumNotSame = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "4",
                        "sumLimitMax": null
                      }
                    ]
                  }
                  //规则8（三大报货）
                  this.bizParam1.dayBizDataSum= {
                      "enabled": false,
                      "limitMax": null
                  }
                  
                  
                  //
                  if (this.$route.query.functionCode == 'BHOTC') {
                      this.bizParam1.selectProductQtySum = {
                          "enabled": false,
                          "ruleItemList": [
                              {
                                  "enabled": false,
                                  "customerType": "单体药店",
                                  "sumLimitMax": null
                              },
                              {
                                  "enabled": false,
                                  "customerType": "连锁总部",
                                  "sumLimitMax": null
                              },
                              {
                                  "enabled": false,
                                  "customerType": "连锁门店",
                                  "sumLimitMax": null
                              },
                              {
                                  "enabled": false,
                                  "customerType": "未定义类型的药店",
                                  "sumLimitMax": null
                              },
                          ]
                      }
                  }
                  //商业
                  if (this.$route.query.functionCode == 'BHSY') {
                      this.bizParam1.selectProductQtySum = {
                          "enabled": false,
                          "ruleItemList": [
                              {
                                  "enabled": false,
                                  "customerType": "商业公司",
                                  "sumLimitMax": null
                              }
                          ]
                      }
                  }
                  //医院
                  if (this.$route.query.functionCode == 'BHRX') {
                      this.bizParam1.selectProductQtySum = {
                          "enabled": false,
                          "ruleItemList": [
                              {
                                  "enabled": false,
                                  "customerType": "医院",
                                  "sumLimitMax": null
                              }
                          ]
                      }
                  }
                  //规则10（库存信息采集）
                   this.bizParam1.selectProductStockQty={
                    "enabled": false,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "单体药店",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "连锁总部",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "连锁门店",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "未定义类型的药店",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "医院",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "商业公司",
                        "sumLimitMax": null
                      }
                    ]
                  }
                }
                //兼容历史数据
                if(!self.bizParam1.diyDayItemBelongSameCustomer){
                  //规则9重置
                  this.bizParam1.diyDayItemBelongSameCustomer = {
                    "enabled": false,
                    "dayLimitMax": null,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": functionCode == 'ZBHZTJ'? "13":'3',
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "10",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      // {
                      //   "enabled": false,
                      //   "customerType": "11",
                      //   "sameLimitMax": null,
                      //   "sumLimitMax": null
                      // }
                    ]
                  }
                }
                //兼容历史数据
                if(!self.bizParam1.diyDayItemSum){
                     //规则10重置
                  this.bizParam1.diyDayItemSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "dayLimitMax": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "3",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "10",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "11",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "15",
                        "sumLimitMax": null
                      },
                    ]
                  }
                  
                }
                //兼容历史数据
                if(!self.bizParam1.diyDayCustomerSumAndSame){
                  //规则11重置
                  self.bizParam1.diyDayCustomerSumAndSame = {
                    "enabled": false,
                    "isSamePerson": null,
                    "dayLimitMax": null,

                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "1",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "2",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "4",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "14",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                    ]
                  }
                }
                if(!self.bizParam1.diyDayCustomerSameSum){
                   //规则12重置
                  self.bizParam1.diyDayCustomerSameSum = {
                      "enabled": false,
                      "isSamePerson": null,
                      "dayLimitMax": null,
                      "ruleItemList": [
                        {
                          "enabled": false,
                          "customerType": "1",
                          "sumLimitMax": null
                        },
                        {
                          "enabled": false,
                          "customerType": "2",
                          "sumLimitMax": null
                        },
                        {
                          "enabled": false,
                          "customerType": "4",
                          "sumLimitMax": null
                        },
                        {
                          "enabled": false,
                          "customerType": "14",
                          "sumLimitMax": null
                        }
                      ]
                  }
                }
                if(functionCode == 'PYQFX' &&!self.bizParam1.isHolidayRule){
                  self.bizParam1.isHolidayRule='N'
                }
                if((functionCode == 'SCDY'||functionCode == 'JPXXSJ') &&!self.bizParam1.dayCustomerSameSum){
                  //专病 规则5 
                  //规则6-1重置
                  this.bizParam1.dayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "1",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "2",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "4",
                        "sumLimitMax": null
                      },
                    ]
                  }
                }
                if (functionCode == 'JPXXSJ' && !self.bizParam1.dayCustomerSumAndSame) {
                  this.bizParam1.dayCustomerSumAndSame = {
                    "enabled": false,
                    "isSamePerson": null,
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "1",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "2",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "4",
                        "sameLimitMax": null,
                        "sumLimitMax": null
                      },
                    ]
                  }
                }
                if(functionCode == 'CPPS' &&!self.bizParam1.dayCustomerSameSum){
                  //专病 规则5 
                  //规则6-1重置
                  this.bizParam1.dayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "药店",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "商业公司",
                        "sumLimitMax": null
                      },
                      {
                        "enabled": false,
                        "customerType": "医院",
                        "sumLimitMax": null
                      },
                      
                    ]
                  }
                }
                if(functionCode == 'FKSXSDD' && !self.bizParam1.orderDayCustomerSameSum){
                  //专病 规则5 
                  //规则6-1重置
                  this.bizParam1.orderDayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                      {
                        "enabled": true,
                        "customerType": "药店",
                        "sumLimitMax": null
                      },
                    ]
                  }
                }
                if((functionCode == 'FKSXSDD'||functionCode == 'BHRX') && !self.bizParam1.selectMedProductQtySum){
                   this.bizParam1.selectMedProductQtySum = {
                        "enabled": false,
                        "ruleItemList": [
                            {
                                "enabled": false,
                                "orgType": "医院",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "保健院",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "诊所",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "门诊",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "社区服务中心",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "乡镇卫生院/室",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "民营医院",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "专科疾病防治院/所/站",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "orgType": "急救中心/站",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "其他基层医疗",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "其他机构",
                                "sumLimitMax": null
                            },  
                            {
                                "enabled": false,
                                "orgType": "未定义类别的",
                                "sumLimitMax": null
                            }
                        ]
                    }
                  // this.bizParam1.orderDayCustomerSameSum = {
                  //   "enabled": false,
                  //   "isSamePerson": 'N',
                  //   "ruleItemList": [
                  //     {
                  //       "enabled": true,
                  //       "customerType": "药店",
                  //       "sumLimitMax": null
                  //     },
                  //   ]
                  // }
                }
                if(functionCode == 'FKSCGDD' && !self.bizParam1.orderDayCustomerSameSum){
                  //专病 规则5 
                  //规则6-1重置
                  this.bizParam1.orderDayCustomerSameSum = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                      {
                        "enabled": true,
                        "customerType": "供应商",
                        "sumLimitMax": null
                      },
                    ]
                  }
                }
                if(functionCode == 'SSGT' &&!self.bizParam1.dayCustomerSameSum){
                  //手术跟台
                  this.bizParam1.dayCustomerSameSum = {
                   "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "医院",
                        "sumLimitMax": null
                      },
                      
                    ]
                    
                  }
                }
                if((functionCode == 'BHOTC'||functionCode == 'BHSY'||functionCode == 'BHRX') &&!self.bizParam1.orderDayCustomerSameSum){
                  let rule={
                    "enabled": false,
                    "customerType": functionCode=='BHOTC'?'药店':functionCode=='BHSY'?'商业公司':'医院',
                    "sumLimitMax": null
                  }
                  this.bizParam1.orderDayCustomerSameSum = {
                   "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [ rule ]
                    
                  }
                }
                if(((functionCode == 'BHOTC'||functionCode == 'BHRX'||functionCode == 'BHSY'||functionCode == 'FKSXSDD'||functionCode == 'FKSCGDD') &&(!self.bizParam1.orderRepeatIntercept&&self.bizParam1.orderRepeatIntercept!=false))||((functionCode == 'SCDY') &&(!self.bizParam1.customerRepeatIntercept&&self.bizParam1.customerRepeatIntercept!=false))){
                  //规则 数据重复性拦截（三大报货、客户拜访）
                  this.bizParam1.orderRepeatIntercept = true
                  this.bizParam1.customerRepeatIntercept = true
                }
                if(functionCode == 'ZBHZTJ' &&!self.bizParam1.dataRepeatIntercept){
                  //专病 规则5 
                  this.bizParam1.dataRepeatIntercept = false
                }
                if((functionCode == 'BHOTC'||functionCode == 'BHRX'||functionCode == 'BHSY'||functionCode == 'FKSXSDD'||functionCode == 'FKSCGDD') &&((!self.bizParam1.monthOrderSumProduct)||(!self.bizParam1.monthOrderSumCompetitor))){
                  let monthOrderSumCompetitor= {
                      "enabled": false,
                      "limitMax": null
                  }
                  this.$set(this.bizParam1,'monthOrderSumCompetitor',monthOrderSumCompetitor)
                  //三大报货和两个fks
                  let monthOrderSumProduct= {
                      "enabled": false,
                      "limitMax": null
                  }
                  
                  console.log('monthOrderSumProduct',self.bizParam1.monthOrderSumProduct);
                  
                  this.$set(this.bizParam1,'monthOrderSumProduct',monthOrderSumProduct)
                }
                if((functionCode == 'FKSXSDD'||functionCode == 'FKSCGDD') &&!self.bizParam1.monthOrderSumProduct){
                  
                  //三大报货和两个fks
                  let monthOrderSumProduct= {
                      "enabled": false,
                      "limitMax": null
                  }
                  
                  console.log('monthOrderSumProduct',self.bizParam1.monthOrderSumProduct);
                  
                  this.$set(this.bizParam1,'monthOrderSumProduct',monthOrderSumProduct)
                }
                // 新增了药店联系人执行规则
                if(functionCode == 'SCDY'&&self.bizParam1.dayItemBelongSameCustomer &&self.bizParam1.dayItemBelongSameCustomer.ruleItemList.length&&self.bizParam1.dayItemSum &&self.bizParam1.dayItemSum.ruleItemList.length&&self.bizParam1.monthItemSameSum &&self.bizParam1.monthItemSameSum.ruleItemList.length){
                    let list2=self.bizParam1.dayItemBelongSameCustomer.ruleItemList
                    let list3=self.bizParam1.dayItemSum.ruleItemList
                    let list4=self.bizParam1.monthItemSameSum.ruleItemList
                    if(!list2.find((item) => item.customerType === '15')){
                        list2.push({
                            customerType: "15",
                            enabled: false
                        })
                    }
                    if(!list3.find((item) => item.customerType === '15')){
                        list3.push({
                            customerType: "15",
                            enabled: false
                        })
                    }
                    if(!list4.find((item) => item.customerType === '15')){
                        list4.push({
                            customerType: "15",
                            enabled: false
                        })
                    }
                }
                if(functionCode == 'SCDY'&&self.bizParam1.diyDayItemBelongSameCustomer &&self.bizParam1.diyDayItemBelongSameCustomer.ruleItemList.length&&self.bizParam1.dayItemSum &&self.bizParam1.dayItemSum.ruleItemList.length&&self.bizParam1.monthItemSameSum &&self.bizParam1.monthItemSameSum.ruleItemList.length){
                  let list2=self.bizParam1.diyDayItemBelongSameCustomer.ruleItemList
                    let list3=self.bizParam1.dayItemSum.ruleItemList
                    let list4=self.bizParam1.monthItemSameSum.ruleItemList
                    if(!list2.find((item) => item.customerType === '15')){
                        list2.push({
                            customerType: "15",
                            enabled: false
                        })
                    }
                    if(!list3.find((item) => item.customerType === '15')){
                        list3.push({
                            customerType: "15",
                            enabled: false
                        })
                    }
                    if(!list4.find((item) => item.customerType === '15')){
                        list4.push({
                            customerType: "15",
                            enabled: false
                        })
                    }
                }
                if(functionCode =='YWCL'&&!self.bizParam1.monthCustomerSameStaff){
                  this.bizParam1.monthCustomerSameStaff = {
                    "enabled": false,
                    "isSamePerson": 'Y',
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "1",
                        "sumLimitMax": null,
                        "isSamePersonExecute":null
                      }
                    ]
                  }
                }
                if(functionCode =='YWCL'&&!self.bizParam1.monthCustomerDifferentStaff){
                  this.bizParam1.monthCustomerDifferentStaff = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                      {
                        "enabled": false,
                        "customerType": "1",
                        "sumLimitMax": null,
                        "isSamePersonExecute":null
                      }
                    ]
                  }
                }
                if(functionCode =='KCXXCJ'&&!self.bizParam1.monthCustomerSameStaff){
                  this.bizParam1.monthCustomerSameStaff = {
                    "enabled": false,
                    "isSamePerson": 'Y',
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        }
                    ]
                  }
                }
                if(functionCode =='KCXXCJ'&&!self.bizParam1.monthCustomerDifferentStaff){
                  this.bizParam1.monthCustomerDifferentStaff = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        },
                        {
                            "enabled": false,
                            "customerType": "2",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        },
                        {
                            "enabled": false,
                            "customerType": "4",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        }
                    ]
                  }
                }
                //规则3
                if (functionCode =='KCXXCJ'&&!self.bizParam1.dayCustomerSumAndSame) {
                    this.bizParam1.dayCustomerSumAndSame = {
                        "enabled": false,
                        "isSamePerson": null,
                        "ruleItemList": [
                            {
                                "enabled": false,
                                "customerType": "1",
                                "sameLimitMax": null,
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "customerType": "2",
                                "sameLimitMax": null,
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "customerType": "4",
                                "sameLimitMax": null,
                                "sumLimitMax": null
                            },
                        ]
                    }
                }
                //规则4
                if (functionCode =='KCXXCJ'&&!self.bizParam1.dayCustomerSameSum) {

                    this.bizParam1.dayCustomerSameSum = {
                        "enabled": false,
                        "isSamePerson": null,
                        "ruleItemList": [
                            {
                                "enabled": false,
                                "customerType": "1",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "customerType": "2",
                                "sumLimitMax": null
                            },
                            {
                                "enabled": false,
                                "customerType": "4",
                                "sumLimitMax": null
                            },
                        ]
                    }
                }
              }
        
              if (res.data.data.bizParam){
                resolve(res.data.data.bizParam.visitRadioList);
              } else {
                resolve(null);
              }
            } else {
              self.$message.error(res.data.msg);
            }
            this.fullscreenLoading = false
          });
      });
    },
    getConfig() {
      let that = this;
      that.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-detail-grp?tenantGuid=${localStorage.guid}&code=GNPZZDCZKG`,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            this.addConfig = data.filter((item) => item.name == '新增字段');
            this.delConfig = data.filter((item) => item.name == '删除字段');
            this.editConfig = data.filter((item) => item.name == '编辑字段');
            //console.log(res);
          }
        });
    },
    getSendTenantList() {
      let that = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        bizState:'Y',
        memberStatus:'ZSHY',
        enterpriseCates: [...this.$getValueListByKey('上游客户分类'), '9901'],
      };
      that.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let { data } = res;
          if (data.data && data.data.records) {
            let list= res.data.data.records|| [];   
            that.sendTenantList=[]
            console.log('list',list);
            if(list.length>0){
              list.forEach(item=>{
                let obj={}
                obj={
                  guid:item.sendTenantGuid,
                  tenantName:item.sendTenantName,
                }
                that.sendTenantList.push(obj)
              })
            }
            if (that.$route.query.guid||this.$route.query.type==3) {
              Promise.all([this.getDetailPromiese(), this.getCustomerListPromiese()]).then(
                ([DetailRes, CustomerListRes]) => {
                  if (this.haveRange) {
                    let arr = [];
                    let visitRadioList = Array.isArray(DetailRes) ? DetailRes : []; // #获取历史配置
                    this.visitRadioListKey.forEach((keyItem) => {
                      // #取客户类型字典配置的选项
                      let itemObj = visitRadioList.find((item) => item.type === keyItem.value);
                      if (itemObj) {
                        arr.push(itemObj);
                      } else {
                        arr.push({
                          name: keyItem.text,
                          type: keyItem.value,
                          competenceParam: 'CUSTOMER_GS',
                          isIntercept: false
                        });
                      }
                    });
                    let ruleList=[]
                    this.visitRadioListKey.forEach((keyItem) => {
                      // #取客户类型字典配置的选项
                      let itemObj = this.holidayRuleList.find((item) => item.type === keyItem.value);
                      if (itemObj) {
                        ruleList.push(itemObj);
                      } else {
                        ruleList.push({
                          name: keyItem.text,
                          type: keyItem.value,
                          isCheckHoliday:true
                        });
                      }
                    });
                    this.visitRadioList = [...arr];
                    this.holidayRuleList = [...ruleList];
                    console.log('pp',this.visitRadioList,this.holidayRuleList);
                    
                  }
                },
              );
            }
          }
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // getSendTenantList() {
    //   let that = this;
    //   let req = {
    //     pageIndex: 1,
    //     pageSize: -1,
    //     currentTenantGuid: localStorage.guid,
    //     tenantName: '',
    //   };
    //   that.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get-simple-tenants`, req).then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       let { data } = res;
    //       if (data.data && data.data.records) {
    //         that.sendTenantList = data.data.records || [];
    //         if (that.$route.query.guid||this.$route.query.type==3) {
    //           Promise.all([this.getDetailPromiese(), this.getCustomerListPromiese()]).then(
    //             ([DetailRes, CustomerListRes]) => {
    //               if (this.haveRange) {
    //                 let arr = [];
    //                 let visitRadioList = Array.isArray(DetailRes) ? DetailRes : []; // #获取历史配置
    //                 this.visitRadioListKey.forEach((keyItem) => {
    //                   // #取客户类型字典配置的选项
    //                   let itemObj = visitRadioList.find((item) => item.type === keyItem.value);
    //                   if (itemObj) {
    //                     arr.push(itemObj);
    //                   } else {
    //                     arr.push({
    //                       name: keyItem.text,
    //                       type: keyItem.value,
    //                       competenceParam: 'CUSTOMER_GS',
    //                     });
    //                   }
    //                 });
    //                 this.visitRadioList = [...arr];
    //                 console.log('pp',this.visitRadioList);
                    
    //               }
    //             },
    //           );
    //         }
    //       }
    //     } else {
    //       that.$message.error(res.data.msg);
    //     }
    //   });
    // },
    
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: [...this.$getValueListByKey('上游客户分类'), '9901'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSelectFactory() {
      var tenantList = this.tenantList;
      tenantList.forEach((item) => {
        if (item.tenantName == this.tenantName) {
          this.getOrganisation(item.guid);
        }
      });
    },
    isContainOrg(arr, guid) {
      if (!arr.length) return 0;
      let flag = arr.findIndex((one) => {
        return one == guid;
      });
      if (flag == -1) {
        return 0;
      } else {
        return 1;
      }
    },
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (list.length) {
        let flag = 0;
        let parentGuids = data.parentGuids ? data.parentGuids : [];
        for (let i = 0; i < list.length; i++) {
          let checkedParentGuids = list[i].parentGuids ? list[i].parentGuids : [];
          if (this.isContainOrg(parentGuids, list[i].guid)) {
            flag = 1;
            break;
          } else if (this.isContainOrg(checkedParentGuids, data.guid)) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        return flag > 0;
      } else {
        return false;
      }
    },
    //选择部门
    handleChooseDepart() {
      this.visible3 = true;
    },
    //获取组织
    getOrganisation(guid) {
      this.fullscreenLoading = true
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
        this.fullscreenLoading = false
      });
    },
    unique(arr) {
      //Set数据结构，它类似于数组，其成员的值都是唯一的
      return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
    },
    //部门弹框选择
    handleNodeClick1(data) {
      this.departmentList = this.$refs.tree.getCheckedNodes(false);

      this.$forceUpdate();
    },
    //确定选择部门
    departmentSure(flag) {
      this.visible3 = false;
      let organisationNameList = [];
      if (this.departmentList.length == 0 && !flag) {
        this.$message.error('请选择部门');
        return;
      }
      this.departmentList.forEach((item) => {
        organisationNameList.push(item.organisationName);
      });
      this.organisationNameList = organisationNameList.join('、');
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选部门！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    //删除单个部门
    delDepartmentSingle(index) {
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);

      // this.departmentList.splice(index,1)
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    getCodeList() {
      let that = this;
      that.api.get(`/${serverConfig.msConfigureService}/dict/data/get-all`).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          localStorage.codeList = JSON.stringify(resp.data.data);
          this.codeList = JSON.parse(localStorage.codeList);
        } else {
          that.$message.error(resp.data.msg);
        }
      });
    },
    customerChange(val, item) {
      
      if (item.type === '4' && val) {
        let doctor = this.visitRadioList.find((item) => item.type === '33' || item.type === '3');
        if (doctor) doctor.competenceParam = val;
      }
      if ((item.type === '33' || item.type === '3') && val) {
        let hospital = this.visitRadioList.find((item) => item.type === '4');
        if (hospital) hospital.competenceParam = val;
      }
      if (item.type === '2' && val) {
        let obj = this.visitRadioList.find((item) => item.type === '10');
        if (obj) obj.competenceParam = val;
      }
      if (item.type === '10' && val) {
        let obj = this.visitRadioList.find((item) => item.type === '2');
        if (obj) obj.competenceParam = val;
      }
    },
    deepCopy(val) {
      return JSON.parse(JSON.stringify(val));
    },
  },
};
</script>
<style lang="less" scoped>
.fks-rule {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
    .rule-input-box{
      width: 90px;
    }
    .txt {
      margin: 0 10px;
      flex-shrink: 0;
    }
    .theme-color {
      color: #4FA1A4;
      font-style: normal;
    }
}
.red{
  color:red
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.content {
  background: #fff;
  font-size: 18px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.title span {
  width: 6px;
  height: 14px;
  background: #4fa1a4;
  display: inline-block;
  margin-right: 10px;
}

.base {
  background: #fff;
  padding: 10px 0;
}

.content h1 {
  margin: 0;
}

.base-content {
  display: flex;
  font-size: 15px;
  padding: 7px 0;
}

.base-content .base-info {
  display: flex;
  align-items: center;
  padding: 0 40px;
}

.base-content .base-info .base-title {
  word-break: keep-all;
}

.button-area {
  display: flex;
  justify-content: space-between;
  padding: 0px 20px 10px 0px;
  margin-top: 0;
}

/deep/.el-checkbox__label {
  display: block;
}
/deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
/deep/ .el-upload-list__item {
  width: 500px;
  // height: 100px;
}
.upload-file-box{
  display: flex;
  flex-direction: column;
  text-align: left;
}
.flex{
  display:flex
}
/deep/ .el-upload-list--picture-card{
  line-height: 0;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item{
  margin: 0 8px 0 0;
}
.checkbox-show {
  display: flex;
  margin-bottom: 10px;
}
.field-show {
  display: flex;
  align-items: center;
  height: 40px;
  padding-left: 10px;
}

.product {
  display: flex;
  align-items: center;
}

.product-img {
  width: 60px;
  height: 40px;
  margin-right: 15px;
}

.product-text {
  width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-main-box {
  height: calc(100vh - 60px - 35px - 66px - 54px - 70px);
}
.vacation-config{
  font-size: 14px;
}
</style>
